{
	"accessibility.table.selectRow": "Sélectionner la ligne",
	"accessibility.topbar.openMainMenu": "Ouvrir le menu principal",
	"accessibility.topbar.openUserMenu": "Ouvrir le menu du compte",
	"account.accountDetails.label.email": "Adresse e-mail",
	"account.accountDetails.label.firstName": "Prénom",
	"account.accountDetails.label.lastName": "Nom",
	"account.accountDetails.label.name": "Nom de profil",
	"account.accountDetails.label.selfDescription": "Brève description",
	"account.applicationDetails.label.heardAboutSource": "Comment avez-vous entendu parler du programme ?",
	"account.applicationDetails.label.productCategories": "Quelles catégories de produits promouvras-tu ?",
	"account.applicationDetails.label.promoteProgramme": "Comment ferez-vous la promotion du Programme d'Affiliation ?",
	"account.applicationDetails.label.recommendedBy": "Par qui avez-vous été recommandé(e) ?",
	"account.paymentInformation.label.accountHolder": "Titulaire du compte",
	"account.paymentInformation.label.bankName": "Nom de la banque",
	"account.paymentInformation.label.bic": "BIC",
	"account.paymentInformation.label.emailAdress": "Adresse e-mail",
	"account.paymentInformation.label.fedwireCode": "Code FEDWIRE",
	"account.paymentInformation.label.iban": "IBAN",
	"account.paymentInformation.label.intervalType": "Intervalle de paiement",
	"account.paymentInformation.label.intlAccountNumber": "Numéro de compte",
	"account.paymentInformation.label.intlBankName": "Nom de la banque",
	"account.paymentInformation.label.paymentType": "Mode de paiement",
	"account.paymentInformation.label.swiftCode": "Code SWIFT",
	"account.paymentInformation.label.taxId": "Numéro fiscal",
	"account.paymentInformation.label.valueAddedTaxId": "Numéro de TVA",
	"account.paymentInformation.taxIdsFromTaxConfirmation": "Nous reprenons ton numéro fiscal et ton numéro de TVA de ta confirmation fiscale.",
	"account.setup.backward": "Retour",
	"account.setup.channels.title": "Sur quelle plateforme vous sentez-vous chez vous ?",
	"account.setup.complete": "Terminer la candidature",
	"account.setup.continue": "Étape suivante",
	"account.setup.firstStep.description": "Pour que nous recevions votre candidature, vous devez remplir et envoyer le formulaire complet.",
	"account.setup.firstStep.title": "Candidature pour {0} par {1}",
	"account.setup.skipSetup.button": "Ignorer la configuration du compte",
	"account.setup.skipSetup.description": "Si vous ignorez la configuration du compte, vous ne serez pas automatiquement inscrit(e) au Programme d'Affiliation standard. Cependant, vous pourrez postuler à tout moment ultérieurement.",
	"account.setup.skipStep": "Passer l’étape",
	"account.setup.step.about.label.creatorName": "Nom du créateur",
	"account.setup.step.about.title": "Orientation affilié",
	"account.setup.step.verification.title": "Informations de facturation",
	"account.setup.stepBackground.label.country": "Dans quel pays as-tu la plus grande portée ?",
	"account.setup.stepBackground.label.skillLevel": "Comment évalues-tu ton niveau d’expertise ?",
	"account.setup.stepBackground.option.beginner": "Débutant",
	"account.setup.stepBackground.option.experienced": "Expérimenté",
	"account.setup.stepBackground.option.professional": "Professionnel",
	"account.setup.stepBackground.title": "Portée & expérience",
	"account.setup.stepBillingPayout.payout.title": "Paiement via",
	"account.setup.stepChannels.title": "Plateforme",
	"account.setup.stepGeneral.label.creatorName": "Quel est ton nom de profil ?",
	"account.setup.stepGeneral.label.selfDescription": "Comment décrirais-tu ton contenu ?",
	"account.setup.stepGeneral.placeholder.creatorName": "Saisis le nom de profil",
	"account.setup.stepGeneral.placeholder.selfDescription": "Décris ton contenu",
	"account.setup.stepGeneral.title": "À propos de toi",
	"account.setup.subtitle": "{name}, tu y es presque !",
	"account.setup.success.button": "Aller au tableau de bord",
	"account.setup.success.nextSteps": "Même si vous n'êtes pas encore activé, vous pouvez déjà vous familiariser avec l'outil.",
	"account.setup.success.subtitle": "Ta candidature pour le programme « {programme} » a été envoyée.",
	"account.setup.success.title": "Configuration du compte terminée !",
	"account.setup.title": "Configuration du compte",
	"account.setup.verification.title": "Adresse de facturation",
	"account.socialMedia.label.channelUri": "URL du canal",
	"account.socialMedia.label.channelUri.other": "URL du site web",
	"account.socialMedia.label.handle": "Nom du canal",
	"account.socialMedia.label.handle.other": "Nom",
	"account.socialMedia.label.mainChannel": "Chaîne principale",
	"account.socialMedia.label.reach": "Portée",
	"account.socialMedia.label.reachCount": "Abonnés",
	"account.socialMedia.label.reachCount.other": "Visiteurs uniques mensuels",
	"account.socialMedia.label.reachCount.youtube": "Abonnés",
	"account.socialMedia.label.tags": "Étiquettes de contenu",
	"account.socialMedia.noEntryNote": "Ajoute dès maintenant ton premier canal ou site web",
	"account.thomannAffiliatePage.button": "Connecter le compte",
	"account.thomannAffiliatePage.description": "Pour pouvoir générer des liens d’affiliation ou créer une landing page dans la boutique Thomann, relie ton compte Clickfire à ton compte Thomann.",
	"account.thomannAffiliatePage.label": "Connectez votre compte Thomann",
	"account.thomannAffiliatePage.notApprovedYet": "Le lien vers votre compte Thomann n'est pas encore possible, car vous n'avez pas encore été approuvé(e) pour le programme partenaire.",
	"affiliateCard.button.details": "Voir les détails",
	"affiliateCard.button.message": "Message",
	"affiliateCard.noChannelsData": "L'affilié n'a fourni aucune information sur ses chaînes",
	"alert.campaign.applicationRejected": "Ta candidature a été refusée",
	"alert.campaign.archived.description": "Les candidatures et les soumissions ne sont plus possibles.",
	"alert.campaign.archived.title": "Cette campagne est archivée",
	"alert.campaign.notAvailableInYourLanguage": "Cette campagne n’est pas disponible dans la langue sélectionnée ({0}). Merci d’en tenir compte lors de ta soumission.",
	"alert.dashboard.noProgrammeAssignement": "Bienvenue sur Clickfire. Vous n’avez pas encore postulé à un programme d’affiliation. Consultez {link} pour commencer dès maintenant.",
	"alert.dashboard.noProgrammeAssignement.link": "Programmes disponibles",
	"alert.mfa.active.title": "L'authentification multi-facteurs est activée",
	"alert.mfa.unverified.title": "Authentification multi-facteurs non terminée",
	"alert.mfaSetup.enrollmentError.description": "Veuillez entrer le code de vérification de votre application d'authentification.",
	"alert.password.managedExternally": "Ton compte est géré par {0}. Tu peux changer ton mot de passe uniquement là-bas.",
	"alert.paymentSettingsConflicting": "Mettre à jour les informations de facturation",
	"alert.paymentSettingsMissing": "Ajouter des informations de facturation",
	"alert.payout.dataIssue.description": "Tes informations de paiement semblent incomplètes ou incorrectes. Merci de les vérifier et de les mettre à jour pour éviter tout problème lors des virements.",
	"alert.payout.dataIssue.title": "Vérifie tes données de paiement",
	"alert.payout.paused.action": "Contacter le support",
	"alert.payout.paused.description": "Tes paiements sont actuellement suspendus. Merci de contacter notre équipe support.",
	"alert.payout.paused.title": "Paiements suspendus",
	"alert.payout.taxConfirmationNotApproved.action": "Vers la confirmation fiscale",
	"alert.payout.taxConfirmationNotApproved.description": "Nous ne pouvons effectuer aucun paiement tant que ta confirmation fiscale n'a pas été validée.",
	"alert.payout.taxConfirmationNotApproved.title": "Paiements suspendus",
	"alert.payoutsPaused": "Paiements suspendus : merci de contacter le support",
	"alert.productreport.fetchError.description": "Malheureusement, nous ne pouvons pas charger votre rapport de produits pour la période sélectionnée car le volume de données est trop important. Nous travaillons à y remédier ! En attendant, veuillez essayer une période plus courte.",
	"alert.taxConfirmationNotApproved": "Paiements suspendus : confirmation fiscale non validée",
	"alert.topProductsWidget.error.title": "Erreur lors du chargement des données",
	"application.label.applicationText": "Texte de candidature",
	"application.noApplications.title": "Aucune candidature reçue pour le moment",
	"applications.label.onlyShowOpenApplications": "Afficher uniquement les candidatures ouvertes",
	"badge.error.language": "Langue",
	"badge.error.requirements.minSubscribers": "Portée",
	"badge.error.requirements.targetCountry": "Pays cible",
	"badge.error.thumbnail": "Vignette",
	"badge.new": "nouveau",
	"banner.v1Migration.link": "Connecte-toi ici une seule fois avec ton compte !",
	"banner.v1Migration.text": "Tu viens de l'ancien Clickfire ?",
	"button.accept": "Accepter",
	"button.acceptApplication": "Accepter",
	"button.addChannel": "Ajouter un canal",
	"button.addMorePlatforms": "Ajouter d'autres plateformes",
	"button.addPrimaryPlatform": "Ajouter une plateforme principale",
	"button.addSelection": "Ajouter la sélection",
	"button.addUserOrSegmentsForCampaignVisibility": "Ajouter Créateur/Groupes de créateurs",
	"button.alreadyAppliedToProgramme": "Déjà postulé",
	"button.alreadyHaveAnClickfireAccount": "Vous avez déjà un compte ? Connectez-vous ici.",
	"button.applied": "Candidature envoyée",
	"button.applyToCampaign": "Postuler",
	"button.applyToProgramme": "Postuler au programme",
	"button.archive": "Archiver",
	"button.archived": "Archiver",
	"button.back": "Retour",
	"button.backToHome": "Retour à l’accueil",
	"button.backToLogin": "Retour à la connexion",
	"button.backToOverview": "Retour à l’aperçu",
	"button.backToPogrammes": "Retour à la liste des programmes",
	"button.backToSignup": "Retour à l'inscription",
	"button.cancel": "Annuler",
	"button.changeBillingData": "Modifier les informations de facturation",
	"button.changePassword": "Modifier le mot de passe",
	"button.changePaymentInformation": "Modifier les informations de paiement",
	"button.close": "Fermer",
	"button.completeMfa": "Terminer le processus",
	"button.confirm": "Confirmer",
	"button.confirmSignupOtp": "Valider le code",
	"button.contact": "Contact",
	"button.continueInDraftMode": "Continuer en mode brouillon",
	"button.copied": "Copié",
	"button.copyCode": "Copier le code",
	"button.copyLink": "Copier le lien",
	"button.createCampaign": "Créer une campagne",
	"button.creatorPreview": "Aperçu créateur",
	"button.delete": "Supprimer",
	"button.deleteCreatorFromSegment": "Supprimer le créateur",
	"button.deleteTranslation": "Supprimer la langue",
	"button.deny": "Refuser",
	"button.details": "Détails",
	"button.discard": "Annuler",
	"button.download": "Télécharger",
	"button.downloadBannerCreative": "Télécharger la bannière créative",
	"button.downloadCsv": "Télécharger .csv",
	"button.edit": "Modifier",
	"button.editCampaign": "Modifier la campagne",
	"button.editLink": "Modifier le lien de suivi",
	"button.filter": "Filtrer",
	"button.forgotPassword": "Mot de passe oublié ?",
	"button.generatePersonalizedTrackingLink": "Générer le lien de suivi",
	"button.goBackToClickReport": "vers le rapport de clics",
	"button.goBackToConversionReport": "Retour au rapport de conversions",
	"button.goToCampaign": "Voir la campagne",
	"button.goToDetails": "Voir les détails",
	"button.goToLogin": "Aller à la connexion",
	"button.grantAccess": "Accorder l'accès",
	"button.hideChannels": "Masquer les chaînes",
	"button.imprint": "Mentions légales",
	"button.login": "Connexion",
	"button.loginWithGoogle": "Connexion avec Google",
	"button.logout": "Déconnexion",
	"button.lookupApplications": "Voir les candidatures",
	"button.lookupSubmissionContentUrl": "Voir le contenu",
	"button.lookupSubmissions": "Gérer les soumissions",
	"button.makeCampaignPrivate": "Définir comme Privée",
	"button.makeCampaignPublic": "Définir comme Publique",
	"button.manageSubmissions": "Gérer les soumissions",
	"button.nextStep": "Étape suivante",
	"button.noAccountSignup": "Pas encore de compte ? Inscris-toi ici !",
	"button.onlyShowMatches": "Afficher seulement les correspondances",
	"button.openCalendar": "Ouvrir le calendrier",
	"button.openSubmissionDetails": "Voir les détails",
	"button.personalizeLink": "Personnaliser le lien",
	"button.privacyPolicy": "Politique de confidentialité",
	"button.publishDraftCampaign": "Publier la campagne",
	"button.removeMfa": "Supprimer l'application d'authentification",
	"button.resendContent": "Soumettre à nouveau",
	"button.resetAllFilter": "Réinitialiser tous les filtres",
	"button.resetPassword": "Réinitialiser le mot de passe",
	"button.retry": "Réessayer",
	"button.retryApplicationFlow": "Réessayer",
	"button.reviewSubmission": "Voir les soumissions",
	"button.revokeAccess": "Révoquer l'accès",
	"button.save": "Enregistrer",
	"button.saveAsDraft": "Enregistrer comme brouillon",
	"button.saveCampaignChanges": "Enregistrer la campagne",
	"button.saveChanges": "Enregistrer",
	"button.savePassword": "Enregistrer le mot de passe",
	"button.send": "Envoyer",
	"button.sendMigrationConformation": "Envoyer le code de vérification",
	"button.sendSubmission": "Soumettre",
	"button.setupMfa": "Configurer l'application d'authentification",
	"button.showAllChannels": "Afficher toutes les chaînes",
	"button.showAllResults": "Afficher tous les résultats",
	"button.showMore": "Afficher plus",
	"button.showMoreChannels": "+ {0} autres canaux",
	"button.signupNow": "Inscription",
	"button.signupWithGoogle": "S’inscrire avec Google",
	"button.submitVideo": "Soumettre une vidéo",
	"button.toDashboard": "Aller au tableau de bord",
	"button.toMerchantSelection": "Vers la sélection de marchands",
	"button.toTransmittal": "Aller à la soumission",
	"button.tos": "CGU",
	"button.translateContentWithAi": "Traduire le contenu avec l’IA",
	"button.uploadAvatar": "Télécharger l’avatar",
	"button.uploadImage": "Télécharger une nouvelle image",
	"button.verifyMfa": "Vérifier le code",
	"button.view": "Voir",
	"campaign.admin.applicationState.accepted": "Accepté",
	"campaign.admin.applicationState.open": "Ouvert",
	"campaign.admin.applicationState.rejected": "Rejeté",
	"campaign.admin.badge.visibility.private": "Privé",
	"campaign.applicationDeadline.inDays": "Date limite de candidature dans {count} jour | Date limite de candidature dans {count} jours",
	"campaign.applicationDeadline.passed": "Date limite de candidature dépassée",
	"campaign.applicationDeadline.today": "Date limite de candidature aujourd’hui",
	"campaign.applicationState.accepted": "Candidature acceptée",
	"campaign.applicationState.open": "Postulé",
	"campaign.applicationState.rejected": "Candidature rejetée",
	"campaign.badge.openApplications": "Candidatures non vérifiées",
	"campaign.badge.unapprovedSubmissions": "Soumissions non vérifiées",
	"campaign.badge.visibility.private": "Exclusif",
	"campaign.badge.visibility.public": "Publique",
	"campaign.badge.wasActiveFor": "Était active pendant {count} jour | Était active pendant {count} jours",
	"campaign.compensationType.fixed": "Montant fixe",
	"campaign.compensationType.open": "Rémunération ouverte",
	"campaign.compensationType.product": "Rémunération en produit",
	"campaign.property.applicationDeadline": "Date limite de candidature",
	"campaign.property.category": "Catégorie",
	"campaign.property.compensation": "Rémunération",
	"campaign.property.compensationType": "Type de rémunération",
	"campaign.property.createdAt": "Créé le",
	"campaign.property.cta": "CTA",
	"campaign.property.description": "Description",
	"campaign.property.keyMessage": "Message clé",
	"campaign.property.requirements": "Exigences",
	"campaign.property.restrictions": "Interdictions",
	"campaign.property.submissionDeadline": "Date limite de soumission",
	"campaign.property.videoRequirements": "Exigences vidéo",
	"campaign.submissionDeadline.inDays": "Date limite de soumission dans {count} jour | Date limite de soumission dans {count} jours",
	"campaign.submissionDeadline.passed": "Date limite de soumission dépassée",
	"campaign.submissionDeadline.today": "Date limite de soumission aujourd’hui",
	"campaign.summary.applicationDeadline": "Candidatures jusqu’au {date}",
	"campaign.summary.submissionDeadline": "Soumissions jusqu’au {date}",
	"campaign.targetCountries.more": "Autres pays",
	"campaign.targetCountries.pinned": "Sélection rapide",
	"campaign.targetCountries.preset.dach": "DACH",
	"campaign.targetCountries.preset.dach.description": "Allemagne, Autriche et Suisse",
	"campaign.targetCountries.preset.germany": "Allemagne",
	"campaign.targetCountries.preset.germany.description": "Marché unique",
	"campaign.targetCountries.preset.worldwide": "Monde entier",
	"campaign.targetCountries.preset.worldwide.description": "Sans restriction de pays",
	"campaign.targetCountries.search": "Rechercher un pays cible …",
	"campaignHistoricStatus.acceptedNoSubmission": "Accepté – En attente",
	"campaignHistoricStatus.applicationPending": "Candidaté",
	"campaignHistoricStatus.applicationRejected": "Candidature rejetée",
	"campaignHistoricStatus.contentApproved": "Contenu approuvé",
	"campaignHistoricStatus.contentRejected": "Contenu rejeté",
	"campaignHistoricStatus.contentSubmitted": "Contenu soumis",
	"campaignType.article": "Article de blog / Article de site web",
	"campaignType.bundle": "Package de contenu",
	"campaignType.shortVideo": "Vidéo courte",
	"campaignType.sparkAd": "SparkAd",
	"campaignType.sponsoredSegment": "Segment YouTube sponsorisé",
	"campaignVisibility.group.creators": "Créateurs",
	"campaignVisibility.group.segments": "Groupes de créateurs",
	"campaignVisibility.placehoder": "Sélectionner Créateur ou Groupes de créateurs",
	"createProgrammeLinkForm.subtitle": "Créer un lien personnalisé",
	"createProgrammeLinkForm.title": "Création de lien de suivi",
	"dashboard.widget.commissions.link": "Paiements",
	"dashboard.widget.conversions.link": "Rapport de conversions",
	"dashboard.widget.topSeller.link": "Rapport sur les produits",
	"days": "0 jours | 1 jour | {count} jours",
	"description.campaignName": "Le nom est uniquement pour vos besoins internes et ne sera pas affiché aux affiliés",
	"description.campaignVisibility": "Vous pouvez rendre et afficher votre campagne exclusivement pour certains créateurs ou groupes de créateurs.",
	"description.compensationProductName": "Ce nom est présenté au créateur comme rémunération.",
	"description.compensationText": "Ce texte est présenté au créateur comme rémunération. Il n’est pas traduit.",
	"description.noVisibilitySettingsYet": "Votre campagne n'est actuellement visible par personne. Ajoutez des créateurs ou des groupes de créateurs pour rendre votre campagne visible, ou définissez-la comme publique.",
	"error.fetch.description": "Une erreur inconnue s'est produite. Veuillez réessayer plus tard.",
	"error.fetch.title": "Erreur lors du chargement des données",
	"error.maxDate": "Date maximale possible : {date}",
	"error.minDate": "Date minimale possible : {date}",
	"error.noAdmin.subtitle": "Tu n’as pas les permissions nécessaires pour voir cette zone. Essaye de te connecter avec un autre compte.",
	"error.noAdmin.title": "Accès refusé !",
	"error.noMerchantAccess.otherMerchants.subtitle": "Malheureusement, vous n'avez pas accès à ce commerçant. Toutefois, nous pouvons vous diriger vers l'un des commerçants pour lesquels vous avez été approuvé.",
	"error.noMerchantAccess.subtitle": "Malheureusement, vous n'avez pas accès à ce commerçant.",
	"error.noMerchantAccess.title": "Accès refusé",
	"error.noValidDateFormat": "Format de date invalide",
	"error.rejectedByMerchant.subtitle": "Nous vous avons envoyé plus d'informations par e-mail. Nous vous remercions de votre compréhension.",
	"error.rejectedByMerchant.title": "Malheureusement, votre candidature a été rejetée",
	"error.signInWithOtp": "Le code de confirmation que vous avez saisi est invalide. Veuillez vérifier votre saisie.",
	"filter.alltime": "Depuis le début",
	"filter.conversionStatus.all": "Tous",
	"filter.conversionStatus.notRejected": "Sans les refusés",
	"filter.filterOptions": "Options de filtre",
	"filter.lastDays": "Dernier jour | Derniers {count} jours",
	"filter.monthRange": "Dernier mois | Derniers {count} mois",
	"filter.price.max": "Prix max",
	"filter.price.min": "Prix min",
	"filter.provisionGroups.all": "Tous les groupes de provision",
	"filter.thisMonth": "Ce mois-ci",
	"filter.thisYear": "Cette année",
	"filter.yearRange": "L'année dernière | Les {count} dernières années",
	"footer.links.v1signin": "Passer à v1",
	"intervalType.halfYear": "Semestriel",
	"intervalType.monthly": "Mensuel",
	"intervalType.quarterYear": "Trimestriel",
	"intervalType.year": "Annuel",
	"label.accessBlocked": "Accès bloqué",
	"label.accessGranted": "Accès autorisé",
	"label.affiliateType.cashback": "Remboursement",
	"label.affiliateType.display": "Publicité display",
	"label.affiliateType.influencer": "Influenceur",
	"label.affiliateType.loyalty": "Fidélité",
	"label.affiliateType.other": "Autre",
	"label.affiliateType.priceComparisonEngine": "Comparateur de prix",
	"label.affiliateType.search": "Publicité search",
	"label.affiliateType.website": "Site web / Contenu",
	"label.affiliates.count": "Partenaires",
	"label.amountInSecondsShort": "{0}s",
	"label.applications.open.total": "Candidatures ouvertes",
	"label.archived": "Archivé",
	"label.averageCartValue": "⌀ Panier",
	"label.calendarWeekShort": "Sem.",
	"label.campaign": "Campagne",
	"label.campaignName": "Nom de la campagne",
	"label.campaignType": "Type de campagne",
	"label.campaignVisibility": "Restreindre la visibilité",
	"label.clicks.count": "Clics",
	"label.columns": "Colonnes",
	"label.comissionRate": "Taux de commission",
	"label.comissionType": "Type de commission",
	"label.commissionAmountRange": "Plage de commissions",
	"label.comparisonPeriod": "Période de comparaison",
	"label.compensationAmountInEur": "Montant en €",
	"label.compensationProductName": "Nom du produit",
	"label.compensationText": "Affichage pour les créateurs",
	"label.contentLength": "Longueur du contenu",
	"label.contentTags": "Étiquettes de contenu",
	"label.conversion.payout": "Commission",
	"label.conversions": "Conversions",
	"label.conversions.displayMode.single": "Conversions individuelles",
	"label.conversions.displayMode.weekly": "Résumé hebdomadaire",
	"label.country": "Pays",
	"label.creator": "Créateur",
	"label.currentPeriod": "Période actuelle",
	"label.customDateRange": "Personnalisé",
	"label.dateRange.comparedTo": "{range} · comparé à {comparison}",
	"label.dateRange.since": "Depuis le {0}",
	"label.dateRange.until": "Jusqu'au {0}",
	"label.deltaShort": "Δ",
	"label.description": "Description",
	"label.draft": "Brouillon",
	"label.durationRemaining": "Durée restante",
	"label.emailShort": "E-mail",
	"label.groupingIntervalOption.date": "Jours",
	"label.groupingIntervalOption.month": "Mois",
	"label.groupingIntervalOption.week": "Semaines",
	"label.heardAboutSource.email": "E-mail",
	"label.heardAboutSource.google": "Google",
	"label.heardAboutSource.notSpecified": "Non spécifié",
	"label.heardAboutSource.otherSource": "Autre source",
	"label.heardAboutSource.personalInvitation": "Invitation personnelle",
	"label.heardAboutSource.recommendation": "Recommandation",
	"label.id": "ID",
	"label.inactive": "Inactif",
	"label.individual": "Choisir individuellement",
	"label.language": "Langue",
	"label.languages": "Langues",
	"label.lastMonths": "des {0} derniers mois",
	"label.lensGrouping.country": "Par pays",
	"label.lensGrouping.group": "Par groupe de provision",
	"label.lensGrouping.publisher": "Tous les partenaires",
	"label.month": "Mois",
	"label.netSumRange": "Recettes (nettes)",
	"label.networkAccess": "Accès au réseau",
	"label.noProgramme": "Sans programme",
	"label.noSales": "Aucune vente",
	"label.noVisibilitySettingsYet": "Votre campagne est invisible",
	"label.openApplications": "Candidatures",
	"label.openApplicationsWithCount": "1 candidature | {count} candidatures",
	"label.openSubmissionsWithCount": "1 soumission | {count} soumissions",
	"label.optional": "(facultatif)",
	"label.others": "Autres",
	"label.partner": "Partenaire",
	"label.payoutFrom": "à partir de {value}",
	"label.payoutRange": "Plage de paiement",
	"label.performance": "Performance",
	"label.performanceIndex": "Index de performance",
	"label.period": "Période",
	"label.platform": "Plateforme",
	"label.platforms": "Plateformes",
	"label.previousPeriod": "Période précédente",
	"label.primaryPlatform": "Plateforme principale",
	"label.programme": "Programme",
	"label.programmeAffiliation": "Affiliation au programme",
	"label.programmeApplicationState": "Statut de la candidature",
	"label.provisionGroup": "Groupe de provision",
	"label.publisherId": "Publisher ID",
	"label.publisherIdShort": "ID",
	"label.rankShort": "#",
	"label.reach": "Portée",
	"label.reach.none": "Aucune",
	"label.referrerBonus": "Bonus de parrainage",
	"label.rejectionReason": "Motif de rejet",
	"label.requirements.minSubscribers": "Minimum d’abonnés / visites",
	"label.requirements.targetCountry": "Pays cible / Pays cibles",
	"label.revenue": "Chiffre d'affaires",
	"label.revenueLastDays": "Chiffre d'affaires des {0} derniers jours",
	"label.saleAmountRange": "Plage de montant des ventes",
	"label.salesValue": "Sales Value",
	"label.salesValueShare": "Part du Sales Value",
	"label.search": "Rechercher…",
	"label.searchScope.ariaLabel": "Sélectionner le champ de recherche",
	"label.searchScope.company": "Société",
	"label.searchScope.conversionId": "Conversion ID",
	"label.searchScope.email": "E-mail",
	"label.searchScope.handle": "Nom du canal",
	"label.searchScope.ignoredTerms": "Ignoré, valeur non valide pour {label} : {terms}",
	"label.searchScope.invoiceNumber": "Numéro de note de crédit",
	"label.searchScope.name": "Nom",
	"label.searchScope.orderNumber": "Numéro de commande",
	"label.searchScope.placeholder": "Rechercher par {label}…",
	"label.searchScope.publisherId": "Publisher ID",
	"label.searchScope.subId1": "Sub ID 1",
	"label.searchScope.subId2": "Sub ID 2",
	"label.selectComparisonPeriod": "Sélectionner la période de comparaison",
	"label.selectPeriod": "Sélectionner la période",
	"label.selected": "{0} sélectionné(s)",
	"label.sortAscending": "Tri croissant",
	"label.sortByLong": "Trier par :",
	"label.sortDescending": "Tri décroissant",
	"label.submissionRejectionReason.campaignArchived": "Campagne archivée",
	"label.submissionRejectionReason.insufficientQuality": "Qualité du contenu insuffisante",
	"label.submissionRejectionReason.linkUnreachable": "Lien de la soumission inaccessible",
	"label.submissionRejectionReason.other": "Autre raison",
	"label.submissionRejectionReason.requirementsNotMet": "Exigences de la campagne non respectées",
	"label.thumbnail.format": "Format",
	"label.thumbnail.size": "Taille",
	"label.thumbnail.size.atLeast": "au moins {0}",
	"label.totalCreators": "Créateurs",
	"label.totalParticipants": "Participants",
	"label.weekOfDate": "Semaine du {0}",
	"label.withProgramme": "Avec programme",
	"label.withSales": "Avec des ventes",
	"label.withoutPending": "Confirmé",
	"label.workInProgress": "En cours de développement",
	"label.yAxisScaleOption.linear": "Linéaire",
	"label.yAxisScaleOption.logarithmic": "Logarithmique",
	"label.year": "Année",
	"label.yourCreativeLink": "Lien créatif",
	"label.yourLink": "Lien de suivi personnalisé",
	"label.yourPublisherId": "ID affilié (affid)",
	"label.yoy": "C/C",
	"language.english": "Anglais",
	"language.german": "Allemand",
	"link.imprint": "https://clickfire.io/en/imprint",
	"link.privacyPolicy": "https://clickfire.io/en/data-protection",
	"link.tos": "https://clickfire.io/en/terms-of-service",
	"modal.archiveCampaign.confirm": "Archiver la campagne",
	"modal.archiveCampaign.deadline.description": "Les créateurs acceptés qui n’ont encore rien soumis ne reçoivent pas de notification séparée.",
	"modal.archiveCampaign.deadline.title": "La campagne se termine avant la date limite de soumission du {date}.",
	"modal.archiveCampaign.description": "« {title} » prend fin et passe dans les archives.",
	"modal.archiveCampaign.label.comment": "Commentaire pour les créateurs concernés",
	"modal.archiveCampaign.openWork.applications": "{count} candidature en attente sera refusée. | {count} candidatures en attente seront refusées.",
	"modal.archiveCampaign.openWork.both": "{applications} et {submissions} seront refusées.",
	"modal.archiveCampaign.openWork.count.applications": "{count} candidature en attente | {count} candidatures en attente",
	"modal.archiveCampaign.openWork.count.submissions": "{count} soumission en attente | {count} soumissions en attente",
	"modal.archiveCampaign.openWork.description": "Les créateurs concernés reçoivent une notification du refus par e-mail.",
	"modal.archiveCampaign.openWork.submissions": "{count} soumission en attente sera refusée. | {count} soumissions en attente seront refusées.",
	"modal.archiveCampaign.placeholder.comment": "p. ex. pourquoi la campagne se termine plus tôt …",
	"modal.archiveCampaign.title": "Archiver la campagne",
	"modal.billingData.label.city": "Ville",
	"modal.billingData.label.companyName": "Entreprise (optionnel)",
	"modal.billingData.label.country": "Pays",
	"modal.billingData.label.firstName": "Prénom",
	"modal.billingData.label.lastName": "Nom",
	"modal.billingData.label.postalCode": "Code postal",
	"modal.billingData.label.street": "Rue",
	"modal.campaignApplication.description": "Explique brièvement pourquoi tu souhaites participer et comment tu veux promouvoir la campagne.",
	"modal.campaignApplication.hint": "Tu peux aussi postuler sans texte.",
	"modal.campaignApplication.label.applicationText": "Texte de candidature",
	"modal.campaignApplication.placeholder": "p. ex. Pourquoi cette campagne te correspond-elle et sur quels canaux ou formats de contenu souhaites-tu la promouvoir ?",
	"modal.campaignApplication.placeholder.openCompensation": "p. ex. Pourquoi cette campagne te correspond-elle, comment souhaites-tu la promouvoir et quelle rémunération envisages-tu ?",
	"modal.campaignApplication.submit": "Envoyer la candidature",
	"modal.campaignApplication.title": "Postuler à la campagne",
	"modal.campaignApplicationDecision.approve.alert.description": "{name} participera ensuite à la campagne « {campaign} » et recevra une notification de l’acceptation.",
	"modal.campaignApplicationDecision.approve.alert.title": "Accepter la candidature de {name} ?",
	"modal.campaignApplicationDecision.approve.confirm": "Confirmer l’acceptation",
	"modal.campaignApplicationDecision.approve.description": "Vérifie et confirme ta décision.",
	"modal.campaignApplicationDecision.approve.title": "Accepter la candidature",
	"modal.campaignApplicationDecision.reject.alert.description": "{name} ne pourra pas participer à la campagne et recevra une notification du refus.",
	"modal.campaignApplicationDecision.reject.alert.title": "Refuser la candidature de {name} ?",
	"modal.campaignApplicationDecision.reject.confirm": "Confirmer le refus",
	"modal.campaignApplicationDecision.reject.description": "Tu peux, si tu le souhaites, envoyer un commentaire à {name}.",
	"modal.campaignApplicationDecision.reject.label.comment": "Commentaire pour le créateur",
	"modal.campaignApplicationDecision.reject.placeholder": "p. ex. une brève justification ou un retour utile sur la candidature …",
	"modal.campaignApplicationDecision.reject.title": "Refuser la candidature",
	"modal.campaignApplicationDecision.text.description": "Reçue le {date}",
	"modal.campaignApplicationDecision.text.title": "Candidature de {name}",
	"modal.campaignCreated.draft.title": "Brouillon créé avec succès !",
	"modal.campaignCreated.title": "Campagne créée avec succès !",
	"modal.campaignSubmissionDecision.approve.alert.description": "La soumission est validée et {name} reçoit une notification de l’acceptation.",
	"modal.campaignSubmissionDecision.approve.alert.title": "Accepter la soumission de {name} ?",
	"modal.campaignSubmissionDecision.approve.confirm.fixed": "Confirmer {amount}",
	"modal.campaignSubmissionDecision.approve.confirm.open": "Fixer la rémunération et accepter",
	"modal.campaignSubmissionDecision.approve.confirm.product": "Confirmer l’acceptation",
	"modal.campaignSubmissionDecision.approve.description": "Vérifie la rémunération et confirme l’acceptation.",
	"modal.campaignSubmissionDecision.approve.fixed.description": "La rémunération a été définie lors de la création de la campagne.",
	"modal.campaignSubmissionDecision.approve.fixed.label": "Rémunération à confirmer",
	"modal.campaignSubmissionDecision.approve.fixed.title": "Rémunération fixe",
	"modal.campaignSubmissionDecision.approve.open.description": "Définis maintenant la rémunération pour cette soumission.",
	"modal.campaignSubmissionDecision.approve.open.error.max": "La rémunération ne peut pas dépasser {amount}.",
	"modal.campaignSubmissionDecision.approve.open.error.min": "Saisis une rémunération supérieure à {amount}.",
	"modal.campaignSubmissionDecision.approve.open.help": "Le montant est crédité à {name} après l’acceptation.",
	"modal.campaignSubmissionDecision.approve.open.label": "Rémunération",
	"modal.campaignSubmissionDecision.approve.open.title": "Rémunération ouverte",
	"modal.campaignSubmissionDecision.approve.product.description": "Le produit a été défini lors de la création de la campagne.",
	"modal.campaignSubmissionDecision.approve.product.label": "Produit",
	"modal.campaignSubmissionDecision.approve.product.title": "Rémunération en produit",
	"modal.campaignSubmissionDecision.approve.title": "Accepter la soumission",
	"modal.campaignSubmissionDecision.content.description": "Soumis le {date}",
	"modal.campaignSubmissionDecision.content.links": "Liens de la soumission",
	"modal.campaignSubmissionDecision.content.note": "Texte libre",
	"modal.campaignSubmissionDecision.content.title": "Contenu de {name}",
	"modal.campaignSubmissionDecision.reject.alert.description": "{name} pourra ensuite envoyer une nouvelle soumission adaptée.",
	"modal.campaignSubmissionDecision.reject.alert.title": "Refuser la soumission de {name} ?",
	"modal.campaignSubmissionDecision.reject.confirm": "Confirmer le refus",
	"modal.campaignSubmissionDecision.reject.description": "Choisis un motif de refus.",
	"modal.campaignSubmissionDecision.reject.label.comment": "Commentaire pour le créateur",
	"modal.campaignSubmissionDecision.reject.label.reason": "Motif du refus",
	"modal.campaignSubmissionDecision.reject.placeholder.comment": "p. ex. une brève justification ou un retour utile …",
	"modal.campaignSubmissionDecision.reject.placeholder.reason": "Sélectionner",
	"modal.campaignSubmissionDecision.reject.title": "Refuser la soumission",
	"modal.cropImage.button.cancel": "Annuler",
	"modal.cropImage.button.confirm": "Appliquer",
	"modal.cropImage.button.reset": "Réinitialiser",
	"modal.cropImage.title": "Modifier l’image",
	"modal.deleteCampaign.description": "Êtes-vous sûr de vouloir supprimer cette campagne ?",
	"modal.deleteCampaign.title": "Supprimer le brouillon",
	"modal.downloadCsv.badge.hasAnyFilterActive": "Filtre actif",
	"modal.downloadCsv.description": "Vous pouvez générer un fichier CSV pour votre rapport. Tous les filtres actuellement activés seront appliqués. Selon la quantité de données, la création peut prendre un moment.",
	"modal.downloadCsv.title": "Télécharger le rapport au format CSV",
	"modal.mfaSetup.description": "Scannez le code QR avec votre application d'authentification ou entrez le code manuellement. Après une configuration réussie, vous devez entrer le PIN directement ici pour terminer le processus.",
	"modal.mfaSetup.factorSecretCode.description": "Utilisez ce code si vous rencontrez des difficultés avec le code QR",
	"modal.mfaSetup.factorSecretCode.title": "Code secret",
	"modal.mfaSetup.title": "Configurer l'authentification multi-facteurs",
	"modal.newPassword.label.password": "Nouveau mot de passe",
	"modal.newPassword.label.passwordConfirm": "Confirmer le mot de passe",
	"modal.newSegment.button.cancel": "Annuler",
	"modal.newSegment.button.confirm": "Créer",
	"modal.newSegment.description": "Quel nom souhaitez-vous donner au nouveau groupe de créateurs ?",
	"modal.newSegment.input.placeholder": "Donnez un nom à votre nouveau groupe de créateurs",
	"modal.newSegment.title": "Créer un nouveau groupe de créateurs",
	"modal.outdatedBrowser.button": "Ignorer le message",
	"modal.outdatedBrowser.description": "Vous utilisez une ancienne version de navigateur que Clickfire ne prend plus en charge. Pour utiliser notre application sans problème, veuillez effectuer une mise à jour vers une version actuelle.",
	"modal.outdatedBrowser.title": "Votre navigateur est obsolète",
	"modal.paymentInformation.label.accountHolder": "Titulaire du compte",
	"modal.paymentInformation.label.bankName": "Nom de la banque",
	"modal.paymentInformation.label.bic": "BIC",
	"modal.paymentInformation.label.emailAdress": "Adresse e-mail",
	"modal.paymentInformation.label.iban": "IBAN",
	"modal.paymentInformation.label.paymentType": "Mode de paiement",
	"modal.programmeApplication.button.confirm": "D'accord, j'ai compris !",
	"modal.programmeApplication.rejected.note": "Si vous remplissez les conditions à une date ultérieure, vous pouvez contacter le support pour postuler à nouveau au programme",
	"modal.programmeApplication.rejected.reason.general.title": "Votre candidature pour \"{0}\" a été refusée.",
	"modal.programmeApplication.rejected.reason.policy.title": "Votre candidature pour \"{0}\" a été refusée en raison de la politique d'affiliation.",
	"modal.programmeApplication.rejected.reason.reach.title": "Votre candidature pour \"{0}\" a été refusée en raison d'une portée insuffisante.",
	"modal.programmeApplication.rejected.reason.topic.title": "Votre candidature pour \"{0}\" a été refusée en raison d'un sujet non pertinent.",
	"modal.removeMfaConfirmation.cancelLabel": "Annuler",
	"modal.removeMfaConfirmation.confirmLabel": "OK",
	"modal.removeMfaConfirmation.description": "Êtes-vous sûr de vouloir supprimer votre application d'authentification ?",
	"modal.removeMfaConfirmation.title": "Supprimer l'application d'authentification",
	"modal.segmentCreatorPreview.title": "Tous les créateurs du groupe \"{0}\"",
	"modal.selectProvisionGroup.button.confirm": "Accorder l'accès",
	"modal.selectProvisionGroup.description": "Un groupe de provisions doit être assigné pour accorder l'accès au programme. Veuillez sélectionner un groupe de provisions.",
	"modal.selectProvisionGroup.placeholder": "Sélectionner un groupe de provisions",
	"modal.selectProvisionGroup.title": "Groupe de provisions requis",
	"modal.submissions.approved.compensation.amount": "Ta rémunération",
	"modal.submissions.approved.compensation.product": "Ton produit",
	"modal.submissions.approved.decisionDate": "Acceptée le {date}",
	"modal.submissions.approved.subtitle": "Le virement du crédit aura lieu lors du prochain cycle de paiement",
	"modal.submissions.approved.subtitleProduct": "Tu reçois le produit de la campagne comme rémunération.",
	"modal.submissions.approved.title": "Votre soumission a été acceptée",
	"modal.submissions.button.addContentUrl": "Ajouter une URL",
	"modal.submissions.exceeded.subtitle": "La campagne n’est malheureusement plus active.",
	"modal.submissions.exceeded.title": "Soumission plus possible",
	"modal.submissions.goToFaq": "Besoin d’aide ? {link}",
	"modal.submissions.goToFaq.link": "Aller à la FAQ",
	"modal.submissions.label.confirmTos": "En acceptant les CGV, vous concluez un contrat entre vous, {merchant} et Clickfire. {link}",
	"modal.submissions.label.confirmTos.link": "Détails dans les CGV",
	"modal.submissions.label.contentUrl": "URL du contenu",
	"modal.submissions.label.videoUrl": "URL de la vidéo",
	"modal.submissions.missing.subtitle": "Veuillez respecter les directives de la campagne",
	"modal.submissions.missing.title": "Nous attendons avec impatience votre contenu !",
	"modal.submissions.note.add": "Ajouter un texte libre",
	"modal.submissions.note.added": "Ajouté",
	"modal.submissions.note.alert": "Indique à l’équipe de la campagne, par exemple, des particularités, des écarts par rapport au briefing ou des passages importants de ton contenu.",
	"modal.submissions.note.back": "Retour à la soumission",
	"modal.submissions.note.edit": "Modifier le texte libre",
	"modal.submissions.note.hint": "Le texte libre est facultatif.",
	"modal.submissions.note.label": "Ton texte libre",
	"modal.submissions.note.placeholder": "p. ex. Le produit est visible à partir de 00:18 …",
	"modal.submissions.note.remove": "Supprimer le texte",
	"modal.submissions.note.save": "Enregistrer le texte",
	"modal.submissions.note.subtitle": "Ajoute si tu le souhaites un message pour l’équipe de la campagne.",
	"modal.submissions.note.title": "Texte libre pour ta soumission",
	"modal.submissions.rejected.reason": "Motif du refus : {reason}",
	"modal.submissions.rejected.subtitle": "Vous pouvez soumettre une nouvelle entrée si vous avez ajusté votre contenu.",
	"modal.submissions.rejected.subtitleCampaignInactive": "La campagne n’est plus active, vous ne pouvez donc plus soumettre de nouveau contenu.",
	"modal.submissions.rejected.title": "Votre soumission a été rejetée",
	"modal.submissions.submitted.subtitle": "Le traitement de vos soumissions prend en moyenne 3-5 jours",
	"modal.submissions.submitted.title": "Votre soumission est en cours de traitement",
	"modal.success.subtitle.splitOne": "Merci de patienter jusqu’à ce que",
	"modal.success.subtitle.splitTwo": " la vidéo soit examinée. Entre-temps, tu peux suivre l’état de ta soumission.",
	"modal.success.title": "Merci pour ta soumission",
	"modal.taxConfirmation.description": "Remplis et signe le formulaire. Nous vérifierons ensuite tes informations.",
	"modal.taxConfirmation.error.description": "Veuillez réessayer.",
	"modal.taxConfirmation.error.title": "Ta confirmation fiscale n'a pas pu être transmise",
	"modal.taxConfirmation.processing": "Enregistrement de tes informations...",
	"modal.taxConfirmation.resubmit.description": "Dès que tu signes le nouveau formulaire, ta validation actuelle n'est plus valable. Tes paiements sont suspendus jusqu'à ce que nous ayons validé la nouvelle confirmation.",
	"modal.taxConfirmation.resubmit.title": "Soumettre à nouveau la confirmation fiscale ?",
	"modal.taxConfirmation.success.description": "Tes paiements reprendront dès que nous l'aurons validée.",
	"modal.taxConfirmation.success.title": "Merci ! Nous vérifions maintenant ta confirmation fiscale.",
	"modal.taxConfirmation.title": "Remplir la confirmation fiscale",
	"modal.tiptaplink.button.delete": "Supprimer",
	"modal.tiptaplink.button.submit": "Enregistrer",
	"modal.tiptaplink.title": "Ajouter un lien",
	"modal.uncopiedLink.cancelLabel": "Rester sur la page",
	"modal.uncopiedLink.confirmLabel": "Vue du programme",
	"modal.uncopiedLink.description": "Tu n’as pas encore copié de lien !",
	"modal.uncopiedLink.title": "Veux-tu vraiment quitter la page ?",
	"modal.unsavedChanges.cancelLabel": "Retour",
	"modal.unsavedChanges.confirmLabel": "Ne pas enregistrer",
	"modal.unsavedChanges.description": "Es-tu sûr de vouloir quitter sans enregistrer ?",
	"modal.unsavedChanges.title": "Attention : modifications non enregistrées",
	"note.aboutNewReportDataLatency": "L'affichage des nouvelles données peut prendre jusqu'à 5 minutes",
	"page.account.applicationAndChannels.title": "Données de candidature & Canaux",
	"page.account.heading": "Votre profil",
	"page.account.merchant.title": "Détails de la candidature",
	"page.account.password.section.changePassword.title": "Changer le mot de passe",
	"page.account.password.section.mfa.description": "La configuration d'une application d'authentification est un excellent moyen d'ajouter une couche de sécurité supplémentaire à votre compte Clickfire, pour garantir que seul vous pouvez vous connecter.",
	"page.account.password.section.mfa.title": "Authentification multi-facteurs",
	"page.account.payment.section.payment.title": "Informations de paiement",
	"page.account.payment.section.publisherData.title": "Détails de facturation",
	"page.account.payment.title": "Détails de facturation et de paiement",
	"page.account.socialMedia.title": "Canaux",
	"page.account.title": "Compte",
	"page.account.uploadAvatar.requirements1": "min. 500×500 px",
	"page.account.uploadAvatar.requirements2": "format : png ou jpg",
	"page.account.widget.passwordAndSecurity.title": "Mot de passe et sécurité",
	"page.admin.affiliate.misc.customTrackingParameters": "Paramètres de suivi personnalisés",
	"page.admin.affiliate.misc.emailAddressInvoice": "Adresse e-mail pour les notes de crédit",
	"page.admin.affiliate.misc.emailNotificationOnInvoice": "Notification email pour une note de crédit",
	"page.admin.affiliate.misc.emailNotificationOnSale": "Notification email lors d'une vente",
	"page.admin.affiliate.misc.language": "Langue pour la communication par e-mail",
	"page.admin.affiliate.misc.rejectConversions": "Rejeter toutes les conversions",
	"page.admin.affiliate.misc.setAutomatically": "Clickfire définit ces valeurs automatiquement à partir de la confirmation fiscale, de sa vérification et des données de facturation. Ne les modifiez qu'en connaissance de cause : elles déterminent si et comment les paiements sont effectués.",
	"page.admin.affiliate.misc.skipInvoiceCreation": "Ignorer la création de facture",
	"page.admin.affiliate.misc.skipInvoiceCreation.description": "Aucune note de crédit n'est créée, l'affilié n'est donc pas payé. Pour les affiliés en Allemagne, cette option est activée automatiquement jusqu'à la validation de la confirmation fiscale.",
	"page.admin.affiliate.misc.skipSepaExport": "Ignorer l'export SEPA",
	"page.admin.affiliate.misc.skipSepaExport.description": "Les paiements à cet affilié ne figurent pas dans le fichier SEPA, par ex. en cas de paiement via PayPal.",
	"page.admin.affiliate.misc.smallBusinessRegulationAffected": "Régime des petites entreprises",
	"page.admin.affiliate.misc.smallBusinessRegulationAffected.description": "L'affilié relève du régime des petites entreprises (§ 19 UStG). Aucune TVA n'apparaît sur la note de crédit.",
	"page.admin.affiliate.misc.taxConfirmationSupplied": "Confirmation fiscale fournie",
	"page.admin.affiliate.misc.taxConfirmationSupplied.description": "Activé : paiement TVA incluse. Désactivé : paiement hors TVA.",
	"page.admin.affiliate.notFound": "Affilié introuvable",
	"page.admin.affiliate.unsavedChanges": "Vous avez des modifications non enregistrées",
	"page.admin.affiliate.widget.applicationData.title": "Données de candidature",
	"page.admin.affiliate.widget.billingAndTaxes.title": "Facturation & taxes",
	"page.admin.affiliate.widget.billingData.title": "Données de facturation",
	"page.admin.affiliate.widget.channels.title": "Canaux",
	"page.admin.affiliate.widget.creatorProfile.title": "Profil créateur",
	"page.admin.affiliate.widget.individualPayout.noAccess": "Le paiement individuel ne peut être configuré qu'une fois que l'utilisateur a accès à ce programme.",
	"page.admin.affiliate.widget.individualPayout.noProvisionGroup": "Un paiement individuel ne peut être défini qu'une fois un groupe de provision attribué.",
	"page.admin.affiliate.widget.individualPayout.override.description": "Remplace le paiement par défaut du groupe de provision attribué pour ce programme.",
	"page.admin.affiliate.widget.individualPayout.override.label": "Remplacer le paiement individuel pour ce programme",
	"page.admin.affiliate.widget.individualPayout.title": "Paiement individuel",
	"page.admin.affiliate.widget.masterData.title": "Données de base",
	"page.admin.affiliate.widget.misc.title": "Divers",
	"page.admin.affiliate.widget.paymentInfo.title": "Informations de paiement",
	"page.admin.affiliate.widget.pecHistory.omitRejected": "Masquer les candidatures rejetées",
	"page.admin.affiliate.widget.pecHistory.title": "Aperçu des campagnes",
	"page.admin.affiliate.widget.productFeedRegistrations.title": "Inscriptions au flux produit",
	"page.admin.affiliate.widget.programmeApplications.title": "Approbations programme & campagne",
	"page.admin.affiliate.widget.programmes.button.grantAccess": "Accorder l'accès au programme",
	"page.admin.affiliate.widget.programmes.button.hold": "Mettre en attente",
	"page.admin.affiliate.widget.programmes.button.resume": "Réactiver",
	"page.admin.affiliate.widget.programmes.button.revokeAccess": "Révoquer l'accès au programme",
	"page.admin.affiliate.widget.provisionGroups.placeholder": "Sélectionner un groupe de provisions",
	"page.admin.affiliate.widget.provisionGroups.title": "Groupe de provision",
	"page.admin.affiliate.widget.urlReferrer.title": "Référent URL",
	"page.admin.applications.history.title": "Historique des candidatures",
	"page.admin.applications.label.onlyShowOpenApplications": "Masquer les candidatures reportées",
	"page.admin.applications.title": "Aperçu des candidatures",
	"page.admin.campaign.applications.title": "Candidatures",
	"page.admin.campaign.apply.card.label.codeDuration": "Durée de validité du code",
	"page.admin.campaign.apply.card.label.videoCode": "Code vidéo",
	"page.admin.campaign.apply.steps.stepFive.alert.description": "Si tu souhaites que le post autorisé n’apparaisse que dans les publicités TikTok et non dans le fil « Pour toi », le fil des abonnés, ta page de profil, les résultats de recherche ou la playlist, active « Diffuser uniquement dans les publicités » dans les paramètres des annonces. Cette fonction est disponible à partir de la version 21.3 de TikTok.",
	"page.admin.campaign.apply.steps.stepFive.alert.title": "Note",
	"page.admin.campaign.apply.steps.stepFive.text": "Colle le code dans notre champ dédié.",
	"page.admin.campaign.apply.steps.stepFive.title": "Étape 5 :",
	"page.admin.campaign.apply.steps.stepFour.listItemOne": "Active « Autorisation d’ancrage » pour nous permettre d’ajouter un lien à ta vidéo. Cette étape est optionnelle.",
	"page.admin.campaign.apply.steps.stepFour.text": "Active « Autorisation d’ancrage ».",
	"page.admin.campaign.apply.steps.stepFour.title": "Étape 4 :",
	"page.admin.campaign.apply.steps.stepOne.text": "Enregistre une vidéo selon les exigences et télécharge-la sur TikTok.",
	"page.admin.campaign.apply.steps.stepOne.title": "Étape 1 :",
	"page.admin.campaign.apply.steps.stepThree.alert.description": "Dans cette vue, tu peux prolonger le code généré par la suite.",
	"page.admin.campaign.apply.steps.stepThree.alert.title": "Note",
	"page.admin.campaign.apply.steps.stepThree.listItemOne": "Sélectionne la durée d’autorisation et clique sur « Autoriser ». Nous recommandons au moins 30 jours.",
	"page.admin.campaign.apply.steps.stepThree.listItemThree": "Enfin, copie le code vidéo en cliquant sur « Gérer ».",
	"page.admin.campaign.apply.steps.stepThree.listItemTwo": "Clique sur « Générer » puis « Enregistrer ».",
	"page.admin.campaign.apply.steps.stepThree.text": "Génère le code vidéo.",
	"page.admin.campaign.apply.steps.stepThree.title": "Étape 3 :",
	"page.admin.campaign.apply.steps.stepTwo.listItemOne": "Ouvre la vidéo TikTok que tu veux autoriser.",
	"page.admin.campaign.apply.steps.stepTwo.listItemThree": "Active le volet « Autorisation pub » et accepte les conditions.",
	"page.admin.campaign.apply.steps.stepTwo.listItemTwo": "Appuie sur les trois points en bas à droite pour ouvrir le menu, puis sélectionne « Paramètres de pub ».",
	"page.admin.campaign.apply.steps.stepTwo.text": "Autorise la vidéo dans l’appli TikTok pour la publicité.",
	"page.admin.campaign.apply.steps.stepTwo.title": "Étape 2 :",
	"page.admin.campaign.apply.steps.title": "Comment générer un code vidéo ?",
	"page.admin.campaign.apply.title.partOne": "Soumettre une vidéo pour le",
	"page.admin.campaign.apply.title.partTwo": "envoyer",
	"page.admin.campaign.archived": "Archivée",
	"page.admin.campaign.description": "Description",
	"page.admin.campaign.noCampaigns.subtitle": "Créez une campagne pour que vos affiliés puissent créer du contenu.",
	"page.admin.campaign.noCampaigns.title": "Aucune campagne active",
	"page.admin.campaign.notFound": "Campagne non trouvée",
	"page.admin.campaign.requirements": "Exigences",
	"page.admin.campaign.submissions.backToCampaign": "Retour à la campagne",
	"page.admin.campaign.submissions.title": "Soumissions",
	"page.admin.campaign.submissions.transimittals": "Soumissions",
	"page.admin.campaign.videoRequirements": "Exigences vidéo",
	"page.admin.campaigns.active.title": "Campagnes actives",
	"page.admin.campaigns.alert.disallowAdvancedEditing": "Des affiliés ont déjà postulé à votre campagne. Par conséquent, tous les détails ne peuvent pas être modifiés.",
	"page.admin.campaigns.button.addRequirement": "Ajouter une exigence",
	"page.admin.campaigns.button.addRestriction": "Ajouter une interdiction",
	"page.admin.campaigns.button.createCampaign": "Créer une campagne",
	"page.admin.campaigns.createNewCampaign": "Créer une nouvelle campagne",
	"page.admin.campaigns.editCampaign": "Modifier la campagne",
	"page.admin.campaigns.label.campaignTitle": "Titre de la campagne",
	"page.admin.campaigns.label.compensationInEuro": "Rémunération (en €)",
	"page.admin.campaigns.label.description": "Description",
	"page.admin.campaigns.label.endOfCampaign": "Fin de la campagne",
	"page.admin.campaigns.label.noLanguages": "Ajoutez maintenant la première langue pour votre nouvelle campagne",
	"page.admin.campaigns.label.thumbnail": "Vignette",
	"page.admin.campaigns.label.uProductOrCategory": "Produit/Catégorie",
	"page.admin.campaigns.newCampaign": "Nouvelle campagne",
	"page.admin.campaigns.plusCreateCampaign": "+ Créer une campagne",
	"page.admin.dashboard.cards.activeCampaigns.linkLabel": "Voir les campagnes actives",
	"page.admin.dashboard.cards.activeCampaigns.title": "Campagnes actives",
	"page.admin.dashboard.cards.openSubmission.linkLabel": "Voir les soumissions",
	"page.admin.dashboard.cards.openSubmission.title": "Soumissions ouvertes",
	"page.admin.dashboard.cards.payouts.linkLabel": "Voir les paiements passés",
	"page.admin.dashboard.cards.payouts.title": "Solde à payer",
	"page.admin.dashboard.dataFreshness": "Les données sont actualisées toutes les 6 heures. Dernière actualisation il y a ~{elapsed}.",
	"page.admin.dashboard.headline": "Tableau de bord de {merchant}",
	"page.admin.dashboard.widget.campaignTodos.label.openApplications": "Candidatures ouvertes",
	"page.admin.dashboard.widget.campaignTodos.label.openSubmissions": "Soumissions",
	"page.admin.dashboard.widget.campaignTodos.title": "To-Dos de campagne",
	"page.admin.dashboard.widget.networkActivity.label.active": "Actifs avec conversions",
	"page.admin.dashboard.widget.networkActivity.label.newPartnersWithoutClick": "Nouveaux partenaires sans clic",
	"page.admin.dashboard.widget.networkActivity.label.newPartnersWithoutConversion": "Nouveaux partenaires sans conversion",
	"page.admin.dashboard.widget.networkActivity.title": "Activité du réseau",
	"page.admin.dashboard.widget.networkByCountry.title": "Réseau par pays",
	"page.admin.dashboard.widget.programmeTodos.label.openApplications": "Candidatures ouvertes",
	"page.admin.dashboard.widget.programmeTodos.label.openConversions": "Conversions en cours de vérification",
	"page.admin.dashboard.widget.programmeTodos.title": "To-Dos du programme",
	"page.admin.dashboard.widget.provisionGroups.title": "Groupes de provision",
	"page.admin.dashboard.widget.topPerformers.label.allCountries": "Tous les pays",
	"page.admin.dashboard.widget.topPerformers.label.allProvisionGroups": "Tous les groupes de provision",
	"page.admin.dashboard.widget.topPerformers.label.byCountry": "Par pays",
	"page.admin.dashboard.widget.topPerformers.label.byProvisionGroup": "Par groupe de provision",
	"page.admin.dashboard.widget.topPerformers.title": "Meilleurs performeurs",
	"page.admin.domains.empty.description": "Vous êtes à jour ! Les nouveaux enregistrements apparaîtront ici dès qu'ils arriveront.",
	"page.admin.domains.empty.title": "Aucun enregistrement de domaine",
	"page.admin.domains.openRegistrations": "Enregistrements de domaine ouverts",
	"page.admin.domains.title": "Domaines",
	"page.admin.merchant.viewTitle": "Bonjour",
	"page.admin.merchants.availableMerchants": "Commerçants disponibles",
	"page.admin.merchants.dashboard.title": "Tableau de bord commerçant",
	"page.admin.merchants.submissions.title": "Soumissions de",
	"page.admin.merchants.title": "Sélection de commerçant",
	"page.admin.partnerReport.title": "Rapport réseau",
	"page.admin.payouts.payouts": "Paiements",
	"page.admin.programmeApplications.history.noApplications.description": "Dès que vous aurez traité une candidature, elle s'affichera ici",
	"page.admin.programmeApplications.history.noApplications.title": "Aucune candidature disponible",
	"page.admin.programmeApplications.noApplications.description": "Vous avez tout traité ! Dès qu'il y aura de nouvelles candidatures, elles s'afficheront ici",
	"page.admin.programmeApplications.noApplications.title": "Aucune candidature disponible",
	"page.admin.segment.addCreators": "Ajouter des créateurs",
	"page.admin.segment.goBackToOverview": "Retour à tous les groupes de créateurs",
	"page.admin.segment.section.campaigns.noCampaigns.description": "Ce groupe de créateurs n'est actuellement utilisé dans aucune campagne active pour la visibilité restreinte.",
	"page.admin.segment.section.campaigns.noCampaigns.title": "Aucune campagne",
	"page.admin.segment.section.campaigns.title": "Campagnes visibles",
	"page.admin.segment.section.creators.title": "Liste des utilisateurs",
	"page.admin.segments.createSegment": "Créer un groupe de créateurs",
	"page.admin.segments.noSegments.subtitle": "Créez votre premier groupe de créateurs.",
	"page.admin.segments.noSegments.title": "Aucun groupe de créateurs",
	"page.admin.segments.title": "Groupes de créateurs",
	"page.admin.submissions.allTransmittals": "Toutes les soumissions",
	"page.admin.submissions.category": "Catégorie",
	"page.admin.submissions.compensation": "Rémunération",
	"page.admin.submissions.dateOfTransmittal": "Date de soumission",
	"page.admin.submissions.helpfulLinks": "Liens utiles",
	"page.admin.submissions.howDoIBookSparkAds": "Comment réserver des Spark Ads dans TikTok Ads Manager ?",
	"page.admin.submissions.howDoIBookSparkAds.link": "https://ads.tiktok.com/help/article/spark-ads-creation-guide?lang=fr#anchor-6",
	"page.admin.submissions.howToGenerateAVideoCode": "Comment générer un code vidéo ?",
	"page.admin.submissions.periodOfValidity": "Période de validité",
	"page.admin.submissions.status": "Statut",
	"page.admin.submissions.tikTokCode": "Code TikTok",
	"page.admin.submissions.transmittalsOf": "Soumissions de",
	"page.admin.submissions.whyShouldIBookSparkAds": "Pourquoi réserver des Spark Ads ?",
	"page.admin.submissions.whyShouldIBookSparkAds.link": "https://ads.tiktok.com/help/article/spark-ads?lang=fr",
	"page.admin.taxConfirmations.history.empty.description": "Les confirmations fiscales apparaissent ici dès qu'elles ont été validées ou refusées.",
	"page.admin.taxConfirmations.history.empty.title": "Aucune confirmation fiscale vérifiée pour l'instant",
	"page.admin.taxConfirmations.history.title": "Confirmations fiscales vérifiées",
	"page.admin.taxConfirmations.open.empty.description": "Dès qu'un affilié soumet une confirmation fiscale, elle apparaît ici.",
	"page.admin.taxConfirmations.open.empty.title": "Aucune confirmation fiscale en attente",
	"page.admin.taxConfirmations.open.title": "Confirmations fiscales en attente",
	"page.admin.taxConfirmations.open.total": "À vérifier",
	"page.affiliate.navigation.details": "Paiement & Autres",
	"page.affiliate.navigation.overview": "Aperçu du compte",
	"page.affiliate.navigation.programmes": "Programmes",
	"page.affiliates.filter.showAllChannels.label": "Toujours afficher tous les canaux",
	"page.affiliates.filter.title": "Options de filtre",
	"page.affiliates.noMatches": "Aucun affilié ne correspond à ta recherche",
	"page.affiliates.showChannelInformation.label": "Afficher les informations sur les chaînes",
	"page.affiliates.single.title": "Détails de l'affilié : {0}",
	"page.affiliates.single.widget.overview.title": "Aperçu du partenaire affilié",
	"page.affiliates.title": "Aperçu des partenaires",
	"page.campaign.archived.title": "La campagne est archivée et ne peut plus être modifiée.",
	"page.campaign.draft.title": "La campagne n’est pas publiée. Il s’agit d’un brouillon.",
	"page.campaigns.navigation.applications": "Candidatures",
	"page.campaigns.navigation.details": "Détails de la campagne",
	"page.campaigns.navigation.submissions": "Soumissions",
	"page.campaigns.navigation.visibility": "Paramètres de visibilité",
	"page.clickDetailSingle.general.title": "Informations générales",
	"page.clickDetailSingle.general.trackingMethod": "Méthode de suivi",
	"page.clickDetailSingle.title": "Détails du clic",
	"page.clickDetailSingle.title.notFound": "Clic non trouvé",
	"page.clickDetailSingle.tracking.browser": "Browser",
	"page.clickDetailSingle.tracking.date": "Date / Heure",
	"page.clickDetailSingle.tracking.originalReferrer": "Original Referrer",
	"page.clickDetailSingle.tracking.programmeUrl": "URL du programme",
	"page.clickDetailSingle.tracking.referrer": "Referrer",
	"page.clickDetailSingle.tracking.title": "Suivi",
	"page.clickDetailSingle.tracking.userAgent": "User-Agent",
	"page.clickReport.realtime.subtitle": "Les {0} derniers clics des dernières 24 heures",
	"page.clickReport.realtime.title": "Clics en temps réel",
	"page.clickReport.title": "Rapport de clics",
	"page.confirm.waitForLogin": "En attente de connexion…",
	"page.content.notFound": "Page non trouvée",
	"page.conversionSingle.general.click": "Clic",
	"page.conversionSingle.general.method": "Méthode de suivi",
	"page.conversionSingle.general.newCustomer": "Nouveau client",
	"page.conversionSingle.general.orderId": "ID de commande",
	"page.conversionSingle.general.programmeType": "Type de programme",
	"page.conversionSingle.general.status": "Statut",
	"page.conversionSingle.general.title": "Informations générales",
	"page.conversionSingle.general.type": "Type",
	"page.conversionSingle.payout.currency": "Devise",
	"page.conversionSingle.payout.payout": "Commission",
	"page.conversionSingle.payout.saleAmount": "Montant des ventes",
	"page.conversionSingle.payout.title": "Commission",
	"page.conversionSingle.title": "Détails de la conversion",
	"page.conversionSingle.title.notFound": "Conversion non trouvée",
	"page.conversionSingle.transactions.title": "Détails de la transaction",
	"page.conversions.cards.commissionReport.subtitle": "des {0} derniers mois",
	"page.conversions.cards.commissionReport.title": "Aperçu des commissions",
	"page.conversions.cards.conversionStatus.subtitle": "des {0} dernières semaines",
	"page.conversions.cards.conversionStatus.title": "État des conversions",
	"page.dashboard.cards.lastInvoice.button": "Télécharger la facture",
	"page.dashboard.cards.lastInvoice.label": "Date de la facture : {0}",
	"page.dashboard.cards.lastInvoice.title": "Crédit actuel",
	"page.dashboard.cards.lastPayout.title": "Dernier paiement",
	"page.dashboard.cards.openPayout.title": "Ouvert actuellement",
	"page.dashboard.title": "Tableau de bord",
	"page.error.button.backToHome": "Retour à l’accueil",
	"page.error.critical.title": "Une erreur inattendue est survenue",
	"page.error.notFound.title": "404 - Non trouvé",
	"page.error.pageNotFound.title": "Page non trouvée",
	"page.error.support.title": "Oups, quelque chose s'est mal passé",
	"page.error.unexpected.withCode": "Code d'erreur : {0}",
	"page.login.label.email": "Adresse e-mail",
	"page.login.label.or": "ou",
	"page.login.label.password": "Mot de passe",
	"page.login.pageTitle": "Connexion",
	"page.login.subtitle": "dans votre réseau d'affiliation {0}",
	"page.login.title": "Salut, ravi de te revoir 😊",
	"page.loginConfirm.waitingForLogin": "Connexion en cours...",
	"page.logout.waitingForLogout": "Déconnexion en cours...",
	"page.merchants.availableMerchants.description": "Tu es inscrit auprès de plusieurs commerçants. Choisis-en un pour continuer.",
	"page.merchants.availableMerchants.title": "Sélection du commerçant",
	"page.merchants.campaigns.archivedCampaigns": "Campagnes archivées",
	"page.merchants.campaigns.backToOverview": "Retour à l’aperçu",
	"page.merchants.campaigns.drafts.title": "Brouillons",
	"page.merchants.campaigns.noCampaigns.subtitle": "Bientôt, vous pourrez postuler à des campagnes passionnantes ici. Revenez bientôt.",
	"page.merchants.campaigns.noCampaigns.title": "Aucune campagne disponible pour le moment",
	"page.merchants.campaigns.openSubmissions.label": "soumission ouverte",
	"page.merchants.campaigns.openSubmissions.label.plural": "soumissions ouvertes",
	"page.merchants.campaigns.showActiveCampaigns.label": "afficher les campagnes actives",
	"page.merchants.campaigns.showArchivedCampaigns.label": "afficher les campagnes archivées",
	"page.merchants.campaigns.title": "Campagnes disponibles",
	"page.merchants.conversions.title": "Rapport de conversions",
	"page.merchants.dashboard.viewTitle": "Content de te revoir,",
	"page.merchants.noMerchant.description": "Tu n’es inscrit auprès d’aucun commerçant. Pour continuer avec Clickfire, inscris-toi auprès d’un commerçant. Retourne sur son site ou contacte le support.",
	"page.merchants.noMerchant.title": "Aucun commerçant trouvé",
	"page.merchants.payouts.title": "Paiements",
	"page.merchants.productReport.title": "Rapport sur les produits",
	"page.merchants.productWidgetDomains.title": "Aperçu des domaines",
	"page.merchants.productWidgetEdit.title": "Modifier le widget",
	"page.merchants.productWidgetNew.title": "Créer un widget",
	"page.merchants.productWidgetPreview.title": "Aperçu du widget",
	"page.merchants.productWidgets.title": "Widgets Produit",
	"page.merchants.programme.applicationStatus": "Statut de la candidature",
	"page.merchants.programme.canApply.1": "Tu n’es pas encore autorisé pour ce programme.",
	"page.merchants.programme.canApply.2": "Postule à ce programme maintenant.",
	"page.merchants.programme.notFound": "Programme non trouvé",
	"page.merchants.programme.yourTrackingLink": "Ton lien de suivi",
	"page.merchants.programmes.backToAvailableProgrammes": "Retour aux programmes disponibles",
	"page.merchants.programmes.backToYourProgrammeApplications": "Retour à tes candidatures",
	"page.merchants.programmes.backToYourProgrammes": "Retour à tes programmes",
	"page.merchants.programmes.lookupApplicationsNow": "Voir les candidatures",
	"page.merchants.programmes.lookupAvailableProgrammesNow": "Voir les programmes disponibles",
	"page.merchants.programmes.noActiveApplicationsFound.1": "Tu n’as encore postulé à aucun programme.",
	"page.merchants.programmes.noActiveApplicationsFound.2": "Consulte les programmes disponibles.",
	"page.merchants.programmes.noAvailableProgrammes": "Aucun programme disponible. Soit le commerçant n’en propose pas, soit tu n’es pas autorisé.",
	"page.merchants.programmes.noProgrammesFound": "Tu n’es pas autorisé pour un programme.",
	"page.merchants.programmes.title": "Programmes",
	"page.merchants.submission.title": "Ta soumission pour « {name} »",
	"page.merchants.submissions.submissions.subtitle": "Découvrez les campagnes disponibles et postulez directement !",
	"page.merchants.submissions.submissions.title": "Aucune soumission disponible pour le moment",
	"page.merchants.submissions.title": "Soumissions",
	"page.merchants.videoSubmission.title": "Soumettre une vidéo",
	"page.mfa.pageTitle": "Authentification multi-facteurs",
	"page.mfa.subtitle": "Veuillez entrer le code de votre application d'authentification.",
	"page.mfa.title": "Votre compte est protégé de manière supplémentaire",
	"page.newCampaign.step.briefing.description": "Définition de la campagne et exigences",
	"page.newCampaign.step.briefing.title": "Étape 3 – Langues & Briefing",
	"page.newCampaign.step.required.description": "Les informations de base pour votre campagne",
	"page.newCampaign.step.required.title": "Étape 1 – Campagne",
	"page.newCampaign.step.setup.description": "Téléchargez une vignette et déterminez la longueur, la durée et les pays cibles de la campagne",
	"page.newCampaign.step.setup.title": "Étape 2 – Configuration",
	"page.newPassword.label.password": "Nouveau mot de passe",
	"page.newPassword.label.passwordConfirm": "Confirmer le mot de passe",
	"page.newPassword.title": "Définir un mot de passe",
	"page.productRedirect.demo.subtitle": "En mode démo, la redirection vers le produit n'est pas possible",
	"page.productRedirect.demo.title": "Mode démo",
	"page.productRedirect.error.notFound.subtitle": "Nous n'avons malheureusement pas pu trouver de page produit pour le produit portant le numéro \"{0}\".",
	"page.productRedirect.error.notFound.title": "Redirection impossible",
	"page.productRedirect.waitForRedirect": "Vous allez être redirigé(e) vers la page du produit...",
	"page.productReport.cards.topSeller.subtitle": "des {0} derniers jours",
	"page.productReport.cards.topSeller.title": "Vos meilleures ventes",
	"page.productReport.cards.topSum.subtitle": "des {0} derniers jours",
	"page.productReport.cards.topSum.title": "Vos plus gros salaires",
	"page.profile.autoUpdateUserProfile": "Votre profil est mis à jour...",
	"page.programme.promotionLinks.subtitle": "Copie les meilleures offres d’un clic !",
	"page.programme.promotionLinks.title": "Liens promotionnels personnalisés",
	"page.programmes.apply.error.subtitle": "Nous n'avons pas pu déterminer le statut de votre candidature ou envoyer votre demande. Si le problème persiste, veuillez contacter notre support.",
	"page.programmes.apply.error.title": "Erreur lors de la candidature au programme",
	"page.programmes.apply.pageTitle": "Candidature",
	"page.programmes.apply.signupPageTitle": "Inscription",
	"page.programmes.apply.waitForProgram": "En attente du programme…",
	"page.resetPassword.subtitle": "Nous t’avons envoyé un e-mail pour réinitialiser ton mot de passe à {email}.",
	"page.resetPassword.title": "Réinitialiser le mot de passe",
	"page.signup.acceptTosOnSignup": "En vous inscrivant, vous acceptez les {tos}",
	"page.signup.acceptTosOnSignup.tos": "conditions de participation",
	"page.signup.bauhaus.waitlist.greeting": "Chers fans de Bauhaus,",
	"page.signup.bauhaus.waitlist.text": "En raison de la forte demande pour notre programme d'affiliation, nous ne pouvons malheureusement pas intégrer davantage d'affiliés pour le moment. Merci de vous inscrire pour rejoindre notre liste d'attente. Nous vous contacterons dès que nous aurons à nouveau des capacités.",
	"page.signup.confirmYourEmail.subtitle": "Nous t’avons envoyé un e-mail de confirmation. Merci de confirmer ton adresse e-mail pour poursuivre ton inscription.",
	"page.signup.confirmYourEmail.title": "Confirme ton adresse e-mail",
	"page.signup.label.email": "Adresse e-mail",
	"page.signup.label.firstName": "Prénom",
	"page.signup.label.lastName": "Nom",
	"page.signup.label.or": "ou",
	"page.signup.label.password": "Mot de passe",
	"page.signup.pageTitle": "Inscription",
	"page.signup.profile.approveSignup": "Confirmer l’inscription",
	"page.signup.profile.label.firstName": "Prénom",
	"page.signup.profile.label.lastName": "Nom",
	"page.signup.profile.subtitle": "Nous devons mieux te connaître avant de continuer.",
	"page.signup.profile.title": "Confirme ton compte",
	"page.signup.subtitle.withMerchant": "Inscris-toi maintenant au programme affilié « {merchant} »",
	"page.signup.subtitle.withoutMerchant": "Inscris-toi maintenant sur Clickfire !",
	"page.signup.thomann.requirement.1": "Minimum 500 visites uniques par jour pour les sites web",
	"page.signup.thomann.requirement.2": "Minimum 5 000 abonnés sur les réseaux sociaux",
	"page.signup.thomann.requirement.readMore.link": "ici",
	"page.signup.thomann.requirement.readMore.text": "Vous trouverez plus d'informations sous {link}.",
	"page.signup.thomann.requirement.title": "Veuillez noter que les exigences minimales suivantes doivent être remplies pour votre inscription :",
	"page.signup.title": "Inscris-toi maintenant",
	"page.signupConfirm.waitingForConfirmation": "Finalisation de l’inscription…",
	"page.signupMigration.otp.subtitle": "Nous avons envoyé un code de vérification à ton adresse e-mail. Saisis-le ici, s'il te plaît.",
	"page.signupMigration.otp.title": "Saisis le code de vérification",
	"page.signupMigration.setPassword.subtitle": "Une fois que tu as créé un mot de passe, tu peux te connecter normalement via la connexion Clickfire v2 habituelle",
	"page.signupMigration.setPassword.title": "Enregistrer le mot de passe",
	"page.signupMigration.subtitle": "Pour que nous puissions t’identifier, nous avons besoin de ton adresse e-mail.",
	"page.signupMigration.title": "Ravi de te voir sur le nouveau Clickfire !",
	"page.v1redirect.waitingForRedirect": "Redirection en cours...",
	"page.v1signin.waitingForLogin": "Connexion en cours...",
	"paymentType.intlTransfer": "SWIFT",
	"paymentType.paypal": "PayPal",
	"paymentType.sepa": "Virement bancaire",
	"placeholder.compensationProductName": "p. ex. Casque Bluetooth",
	"placeholder.compensationText": "p. ex. Rémunération à convenir",
	"placeholder.compensationType": "Choisir le type de rémunération",
	"placeholder.password": "Saisir le mot de passe",
	"popover.embedCodeCopiedSuccessfully": "Code copié !",
	"popover.linkCopiedSuccessfully": "Lien copié !",
	"popover.segmentCreators.doubleCheck": "Supprimer le créateur du groupe ?",
	"productWidget.copy.embedDescription": "Placez ce bloc de code à l'endroit où vous souhaitez afficher le widget. Associé à la balise script, votre widget configuré y sera chargé.",
	"productWidget.copy.embedLabel": "Code du widget",
	"productWidget.copy.scriptDescription": "Ajoutez cette balise script dans le <head> de votre page. Elle est nécessaire pour que le widget puisse être chargé et rempli de contenu.",
	"productWidget.copy.scriptLabel": "Balise script",
	"productWidget.copy.title": "Intégrer le widget",
	"productWidget.create.button": "Créer un widget",
	"productWidget.delete.cancelLabel": "Annuler",
	"productWidget.delete.confirmDescription": "Vous pouvez continuer à utiliser le widget sur votre site, mais vous ne pourrez plus consulter de statistiques.",
	"productWidget.delete.confirmLabel": "Supprimer",
	"productWidget.delete.confirmTitle": "Voulez-vous vraiment supprimer le widget produit « {name} » ?",
	"productWidget.delete.error": "Erreur lors de la suppression du widget produit « {name} ».",
	"productWidget.delete.success": "Le widget produit « {name} » a été supprimé.",
	"productWidget.domain.admin.actionError": "L'action n'a pas pu être effectuée. Veuillez réessayer.",
	"productWidget.domain.admin.publisherId": "ID : {id}",
	"productWidget.domain.admin.registrationFor": "Enregistrement de domaine pour",
	"productWidget.domain.delete.cancelLabel": "Annuler",
	"productWidget.domain.delete.confirmDescription": "Après la suppression, vos widgets produit ne fonctionneront plus sur ce domaine.",
	"productWidget.domain.delete.confirmLabel": "Supprimer",
	"productWidget.domain.delete.confirmTitle": "Voulez-vous vraiment supprimer le domaine « {name} » ?",
	"productWidget.domain.delete.error": "{domain} n'a pas pu être supprimé. Veuillez réessayer.",
	"productWidget.domain.delete.success": "{domain} a été supprimé.",
	"productWidget.domain.form.invalidDomain": "Veuillez saisir un domaine valide (par ex. votre-site.fr).",
	"productWidget.domain.status.accepted": "Accepté",
	"productWidget.domain.status.rejected": "Rejeté",
	"productWidget.domain.status.submitted": "Soumis",
	"productWidget.domain.submit.button": "Soumettre le domaine",
	"productWidget.domain.submit.error": "Le domaine n'a pas pu être soumis. Veuillez réessayer.",
	"productWidget.domain.submit.placeholder": "votre-site.fr",
	"productWidget.domain.submit.success": "{domain} a été soumis pour vérification.",
	"productWidget.domain.submit.validationError": "Veuillez saisir un domaine valide.",
	"productWidget.domain.table.delete": "Supprimer le domaine",
	"productWidget.domain.table.empty": "Aucun domaine soumis pour le moment.",
	"productWidget.domain.table.name": "Nom de domaine",
	"productWidget.domain.table.status": "Statut",
	"productWidget.domain.table.submittedAt": "Soumis le",
	"productWidget.domainPending.description": "Super ! Vous avez enregistré un domaine. Vous pouvez déjà créer des widgets produit, mais ils ne fonctionneront techniquement sur votre site qu'une fois le domaine validé par nos soins.",
	"productWidget.domainRejected.description": "Malheureusement, votre domaine a été refusé. Pour utiliser les widgets produit, vous devez disposer d'au moins un domaine actif. Vous pouvez dès maintenant {domainLink} ou contacter notre {supportLink} en cas de questions.",
	"productWidget.domainRejected.domainLink": "soumettre un autre domaine",
	"productWidget.domainRejected.supportLink": "équipe support",
	"productWidget.duplicate.copySuffix": " (copie)",
	"productWidget.edit.configuratorTitle": "Modifier le widget",
	"productWidget.edit.notFound": "Ce widget produit est introuvable.",
	"productWidget.edit.saveButton": "Enregistrer les modifications",
	"productWidget.edit.saveError": "Les modifications n'ont pas pu être enregistrées. Veuillez réessayer.",
	"productWidget.edit.saveSuccess": "Les modifications ont été enregistrées.",
	"productWidget.empty.features.catalog.description": "Recherchez des produits par nom ou numéro et intégrez-les au widget.",
	"productWidget.empty.features.catalog.title": "Catalogue de produits intégré",
	"productWidget.empty.features.noCode.description": "Lancez vos propres publicités web gratuites en quelques minutes, sans connaissances.",
	"productWidget.empty.features.noCode.title": "Aucune compétence web requise",
	"productWidget.empty.features.responsive.description": "Optimisé pour les appareils courants : mobile, tablette et ordinateur.",
	"productWidget.empty.features.responsive.title": "Design responsive",
	"productWidget.empty.headline": "Faites des product widgets votre placement de produit visuel",
	"productWidget.empty.modalSubtitle": "Après avoir saisi votre domaine, vous pourrez créer votre premier product widget.",
	"productWidget.empty.notApproved": "Vous devez être accepté sur au moins un programme pour pouvoir utiliser les product widgets.",
	"productWidget.empty.subtitle": "Avec les product widgets, vous diffusez facilement et rapidement des publicités visuelles sur votre site. Il vous suffit de faire approuver votre domaine par nos affiliate managers.",
	"productWidget.new.backToOverview": "Retour à l'aperçu des widgets",
	"productWidget.new.brandPlaceholder": "Par marque…",
	"productWidget.new.buttonLabelDescription": "Affiché sur le bouton de chaque produit, p. ex. « Voir en boutique ». Si le champ est vide, un texte par défaut est utilisé.",
	"productWidget.new.buttonLabelShortDescription": "Remplace le texte du bouton lorsque le widget est affiché en format étroit, p. ex. sur smartphone.",
	"productWidget.new.categoryPlaceholder": "Par catégorie…",
	"productWidget.new.configuratorTitle": "Configurateur de widget",
	"productWidget.new.createButton": "Créer le widget produit",
	"productWidget.new.errors.name": "Veuillez saisir un nom de widget.",
	"productWidget.new.errors.productCount": "Veuillez définir le nombre de produits.",
	"productWidget.new.errors.products": "Veuillez ajouter au moins un produit.",
	"productWidget.new.errors.programme": "Veuillez sélectionner un ID de programme.",
	"productWidget.new.errors.shop": "Veuillez sélectionner une boutique.",
	"productWidget.new.errors.title": "Veuillez corriger les points suivants :",
	"productWidget.new.fields.buttonLabel": "Texte du bouton",
	"productWidget.new.fields.buttonLabelShort": "Texte du bouton (court)",
	"productWidget.new.fields.layout": "Mise en page",
	"productWidget.new.fields.name": "Nom du widget",
	"productWidget.new.fields.payoutInfo": "Info sur la rémunération",
	"productWidget.new.fields.productCount": "Curseur de quantité de produits",
	"productWidget.new.fields.programme": "ID de programme",
	"productWidget.new.fields.quickSelect": "Sélection rapide",
	"productWidget.new.fields.shop": "Boutique",
	"productWidget.new.fields.sort": "Tri",
	"productWidget.new.fields.subId": "Sub-ID",
	"productWidget.new.fields.topsellerFilter": "Filtre meilleures ventes",
	"productWidget.new.filter.individual": "Individuel",
	"productWidget.new.filter.overall": "Global",
	"productWidget.new.layout.centered": "Centré",
	"productWidget.new.layout.default": "Par défaut",
	"productWidget.new.optional": "facultatif",
	"productWidget.new.previewHint": "Pour obtenir un aperçu, vous devez sélectionner au moins une boutique.",
	"productWidget.new.productCountValue": "{count} produits",
	"productWidget.new.productSelection": "Sélection de produits",
	"productWidget.new.programmePlaceholder": "Ajoutez ici votre ID de programme",
	"productWidget.new.saveError": "Le widget produit n'a pas pu être enregistré. Veuillez réessayer.",
	"productWidget.new.saveSuccess": "Le widget produit a été enregistré.",
	"productWidget.new.shopPlaceholder": "Sélectionnez une boutique",
	"productWidget.new.skuHint": "Vous trouverez les numéros de produit directement sur la page produit dans la",
	"productWidget.new.skuPlaceholder": "Saisissez le numéro de produit (SKU)",
	"productWidget.new.skuShopLink": "boutique {shop}",
	"productWidget.new.sort.priceAsc": "Prix croissant",
	"productWidget.new.sort.priceDesc": "Prix décroissant",
	"productWidget.new.step.layout": "Mise en page",
	"productWidget.new.step.product": "Produit",
	"productWidget.new.step.tracking": "Suivi",
	"productWidget.new.subIdDescription": "Ce sub-ID est utilisé à des fins d'analyse et est donc généré automatiquement. Le modifier peut entraîner des problèmes d'analyse. Ne le modifiez que si vous savez ce que vous faites.",
	"productWidget.new.subIdPlaceholder": "Sub-ID (facultatif)",
	"productWidget.new.subcategoryPlaceholder": "Par sous-catégorie…",
	"productWidget.new.topsellerFilterDescription": "« Global » affiche les meilleures ventes de la boutique. « Individuel » filtre les produits de manière dynamique.",
	"productWidget.new.type.dynamic": "Meilleures ventes",
	"productWidget.new.type.static": "Recherche de produits",
	"productWidget.preview.backToOverview": "Retour à la vue d'ensemble",
	"productWidget.preview.description": "Voici comment votre widget apparaîtra sur votre site web.",
	"productWidget.preview.title": "Aperçu du widget",
	"productWidget.table.actions.copyHtml": "Copier le HTML",
	"productWidget.table.actions.delete": "Supprimer",
	"productWidget.table.actions.duplicate": "Dupliquer",
	"productWidget.table.actions.edit": "Modifier",
	"productWidget.table.actions.preview": "Aperçu",
	"productWidget.table.clicks": "Clics",
	"productWidget.table.empty": "Aucun widget produit créé pour le moment.",
	"productWidget.table.impressions": "Impressions",
	"productWidget.table.name": "Nom",
	"productWidget.table.type": "Comportement",
	"programme.button.programmeDetails": "Voir les détails",
	"programme.hint.enableCompactUrl": "Lien court fourni par Clickfire",
	"programme.label.addSubIds": "Ajouter des sous-ID",
	"programme.label.applicationStatus": "Statut",
	"programme.label.appliedAt": "Postulé le",
	"programme.label.creative": "Créatif",
	"programme.label.customUrl": "URL personnalisée",
	"programme.label.enableCompactUrl": "URL compacte",
	"programme.label.note": "Remarque",
	"programme.noValidApplicationDate": "Inconnu",
	"programme.placeholder.creative": "Sélectionner un créatif",
	"programme.placeholder.customUrl": "Saisis ton URL personnalisée…",
	"programme.placeholder.subId1": "Sous-ID 1",
	"programme.placeholder.subId2": "Sous-ID 2",
	"programmeAccessStatus.grantedBy": "Accès accordé par {0}",
	"programmeAccessStatus.hasAccess": "Accès accordé",
	"programmeAccessStatus.noAccess": "Aucun accès",
	"programmeAccessStatus.onHold": "Mis en attente",
	"programmeAccessStatus.pending": "Candidature en attente",
	"programmeAccessStatus.rejected": "Refusé",
	"programmeAccessStatus.revokedBy": "Accès révoqué par {0}",
	"programmeApplication.acceptedBy": "Accepté par {0}",
	"programmeApplication.appliedToProgramme": "Candidature pour",
	"programmeApplication.button.approve": "Accepter la candidature",
	"programmeApplication.button.approveDisabled": "L'accès au programme ne peut être accordé que si un groupe de provisions a été assigné à l'affilié.",
	"programmeApplication.button.reject": "Refuser la candidature",
	"programmeApplication.details.city": "Ville :",
	"programmeApplication.details.country": "Pays :",
	"programmeApplication.details.descriptionPromotionMethod": "Voici comment je souhaite promouvoir le programme",
	"programmeApplication.details.eMailAddress": "Adresse e-mail :",
	"programmeApplication.details.highestReachCountry": "Pays avec la plus grande portée :",
	"programmeApplication.details.recommendedBy": "Recommandé par :",
	"programmeApplication.details.title": "Informations sur le candidat",
	"programmeApplication.individualPayout.amountInPercent.label": "Valeur en pourcentage (%)",
	"programmeApplication.individualPayout.description": "Remplace la commission du groupe",
	"programmeApplication.individualPayout.label": "Verser un paiement individuel",
	"programmeApplication.individualPayout.referrerBonus.label": "Bonus de parrainage (%)",
	"programmeApplication.noChannelsData": "Le candidat n'a fourni aucune information sur ses chaînes",
	"programmeApplication.onHold": "En attente",
	"programmeApplication.rejectedBy": "Refusé par {0}",
	"programmeApplication.rejection.general": "Général",
	"programmeApplication.rejection.policy": "Ne correspond pas à la politique d'affiliation",
	"programmeApplication.rejection.reach": "Portée trop faible",
	"programmeApplication.rejection.topic": "Sujet non spécifique",
	"reachFilter.all.label": "Toutes les portées",
	"segments.label.singleUsers": "Utilisateurs individuels",
	"sidebar.signedInAs": "Connecté en tant que",
	"state.admin.submission.approved": "Accepté",
	"state.admin.submission.exceeded": "Expiré",
	"state.admin.submission.missing": "Soumission manquante",
	"state.admin.submission.rejected": "Rejeté",
	"state.admin.submission.submitted": "En cours de vérification",
	"state.approved": "Approuvé",
	"state.paid": "Payé",
	"state.pending": "En attente",
	"state.rejected": "Rejeté",
	"state.submission.approved": "Soumission acceptée",
	"state.submission.exceeded": "Période de soumission expirée",
	"state.submission.missing": "Soumission requise",
	"state.submission.paidOut": "Soumission payée",
	"state.submission.rejected": "Soumission rejetée",
	"state.submission.submitted": "Soumission en cours de vérification",
	"state.unapproved": "unapproved",
	"state.unknown": "Inconnu",
	"submission.label.creationDate": "Soumis le",
	"submission.label.decisionDate": "Décidé le",
	"submission.property.category": "Catégorie",
	"submission.property.codeExpiryDate": "Période de validité",
	"submission.property.compensation": "Rémunération",
	"submission.property.createdAt": "Date de soumission",
	"submission.property.state": "Statut",
	"submission.property.tiktokCode": "Code TikTok",
	"submissionState": "Soumission : {0}",
	"submissions.label.onlyShowOpenSubmissions": "Afficher uniquement les soumissions ouvertes",
	"submissions.noSubmissions.title": "Aucune soumission disponible",
	"table.adminConversions.noEntries": "Il n’y a aucune conversion pour la sélection actuelle",
	"table.adminPayouts.noEntries": "Il n’y a pas encore de paiements",
	"table.adminPayouts.title.actions": "Télécharger",
	"table.adminPayouts.title.affiliate": "Affilié",
	"table.adminPayouts.title.affiliateId": "ID affilié",
	"table.adminPayouts.title.compensation": "Montant",
	"table.adminPayouts.title.date": "Date de facture",
	"table.adminPayouts.title.id": "Numéro de facture",
	"table.adminPayouts.title.payout": "Montant payé",
	"table.adminSubmissions.noEntries": "Aucune soumission pour cette campagne",
	"table.adminSubmissions.title.affiliate": "Affilié",
	"table.adminSubmissions.title.affiliateId": "ID affilié",
	"table.adminSubmissions.title.contentUrl": "Contenu",
	"table.adminSubmissions.title.creator": "Nom du créateur",
	"table.adminSubmissions.title.date": "Date",
	"table.adminSubmissions.title.details": "Détails",
	"table.adminSubmissions.title.rejectionInformation": "Motif de rejet",
	"table.adminSubmissions.title.state": "Statut",
	"table.applications.title.applicationText": "Texte libre",
	"table.applications.title.categories": "Catégories de produits",
	"table.applications.title.channels": "Canaux",
	"table.applications.title.creator": "Nom du créateur",
	"table.applications.title.followerCount": "Abonnés",
	"table.applications.title.languages": "Langues",
	"table.applications.title.platforms": "Plateformes",
	"table.applications.title.state": "Statut",
	"table.clicks.noEntries": "Vous n’avez pas encore de clics",
	"table.conversions.noEntries": "Tu n’as pas encore de conversions",
	"table.conversions.title.invoiceNumber": "Numéro de note de crédit",
	"table.conversions.title.orderNumber": "Numéro de commande",
	"table.conversions.title.partner": "Partenaire",
	"table.conversions.title.payout": "Commission",
	"table.conversions.title.programme": "Programme",
	"table.conversions.title.rejectionReason": "Motif de rejet",
	"table.conversions.title.saleAmount": "Montant des ventes",
	"table.conversions.title.status": "Statut d’approbation",
	"table.footer.entriesPerPage": "Entrées par page",
	"table.generic.title.date": "Date",
	"table.generic.title.publisherId": "Publisher ID",
	"table.generic.title.referrer": "Référent",
	"table.generic.title.subId1": "Sous-ID 1",
	"table.generic.title.subId2": "Sous-ID 2",
	"table.networkReport.noEntries": "Aucun partenaire correspondant trouvé",
	"table.noEntries": "Aucune entrée",
	"table.payouts.footer.payoutSum": "Total des paiements",
	"table.payouts.noEntries": "Tu n’as pas encore de paiements",
	"table.payouts.title.actions": "Télécharger",
	"table.payouts.title.amount": "Montant payé",
	"table.payouts.title.date": "Date de facture",
	"table.payouts.title.id": "Numéro de facture",
	"table.payouts.title.merchant": "Commerçant",
	"table.pecHistory.campaignCompleted": "Campagne terminée",
	"table.pecHistory.campaignOngoing": "Campagne en cours",
	"table.pecHistory.hasSubmission": "Soumission présente",
	"table.pecHistory.noEntries": "Aucune participation à une campagne trouvée",
	"table.pecHistory.noSubmission": "Aucune soumission",
	"table.pecHistory.title.campaignCompleted": "Campagne terminée",
	"table.pecHistory.title.campaignName": "Nom de la campagne",
	"table.pecHistory.title.company": "Entreprise",
	"table.pecHistory.title.compensationReceived": "Compensation reçue",
	"table.pecHistory.title.status": "Statut de candidature",
	"table.products.noEntries": "Aucune transaction trouvée",
	"table.products.title.articleNumber": "Réf. article",
	"table.products.title.category": "Catégorie",
	"table.products.title.grossNet": "Recettes (nettes)",
	"table.products.title.grossSum": "Recettes (brutes)",
	"table.products.title.imageUrl": "Image",
	"table.products.title.name": "Nom",
	"table.products.title.priceGross": "Prix (brut)",
	"table.products.title.priceNet": "Prix (net)",
	"table.products.title.quantity": "Quantité",
	"table.segmentCreators.empty.action": "Ajouter des créateurs",
	"table.segmentCreators.empty.description": "Aucun créateur n'a encore été ajouté à ce groupe de créateurs.",
	"table.segmentCreators.empty.title": "Aucun créateur disponible",
	"table.segmentCreators.title.actions": "Actions",
	"table.submissions.emptyState": "Aucune soumission disponible",
	"table.submissions.title.campaign": "Campagne",
	"table.submissions.title.date": "Date",
	"table.submissions.title.details": "Détails",
	"table.submissions.title.merchant": "Commerçant",
	"table.submissions.title.state": "Statut",
	"taxConfirmation.action.approve": "Valider",
	"taxConfirmation.action.openDocument": "Ouvrir le PDF",
	"taxConfirmation.action.openDocumentInNewTab": "Ouvrir dans un nouvel onglet",
	"taxConfirmation.action.reject": "Refuser",
	"taxConfirmation.label.approvedBy": "Approuvé par {name}",
	"taxConfirmation.label.loadingDocument": "Chargement du PDF...",
	"taxConfirmation.label.rejectedBy": "Refusé par {name}",
	"taxConfirmation.label.rejectionComment": "Commentaire pour l'affilié (facultatif)",
	"taxConfirmation.label.rejectionReason": "Motif du refus",
	"taxConfirmation.label.submittedAt": "Soumise le {date}",
	"taxConfirmation.rejectionReason.incomplete": "Informations incomplètes",
	"taxConfirmation.rejectionReason.invalidTaxNumber": "Numéro fiscal invalide",
	"taxConfirmation.rejectionReason.other": "Autre",
	"taxConfirmation.rejectionReason.wrongTaxStatus": "Informations contradictoires sur le statut fiscal",
	"toast.addUserOrSegmentsForCampaignVisibility.success.title": "Créateurs et groupes de créateurs ajoutés avec succès",
	"toast.applyToProgramme.error.alreadyApproved": "Tu es déjà autorisé pour ce programme.",
	"toast.applyToProgramme.error.applicationPending": "Tu as déjà postulé pour ce programme.",
	"toast.applyToProgramme.error.description": "Une erreur inconnue est survenue. Merci de réessayer ou de contacter le support.",
	"toast.applyToProgramme.error.title": "Erreur de candidature",
	"toast.applyToProgramme.needsToCompleteAccountSetup.title": "Tu dois terminer la configuration du compte avant de postuler.",
	"toast.applyToProgramme.rejectedByMerchant.title": "Malheureusement, votre candidature au réseau a été rejetée et vous ne pouvez donc pas postuler au programme",
	"toast.applyToProgramme.success.title": "Candidature envoyée avec succès",
	"toast.approveSubmission.success.title": "Soumission approuvée avec succès",
	"toast.archiveCampaign.success.title": "Campagne archivée avec succès",
	"toast.campaignApplication.error.title": "Ta candidature n’a pas pu être envoyée",
	"toast.campaignApplication.success.description": "Ta candidature a été envoyée. Tu seras informé·e par e-mail de la décision.",
	"toast.campaignApplication.success.title": "Candidature envoyée",
	"toast.campaignApplicationApproval.error.title": "La candidature n’a pas pu être acceptée",
	"toast.campaignApplicationApproval.success.description": "La candidature de {name} pour la campagne « {campaign} » a été acceptée.",
	"toast.campaignApplicationApproval.success.title": "Candidature acceptée",
	"toast.campaignApplicationRejection.error.title": "La candidature n’a pas pu être refusée",
	"toast.campaignApplicationRejection.success.description": "{name} a reçu une notification du refus.",
	"toast.campaignApplicationRejection.success.title": "Candidature refusée",
	"toast.campaignArchive.error.title": "La campagne n’a pas pu être archivée",
	"toast.campaignArchive.success.description": "« {title} » se trouve maintenant dans les archives.",
	"toast.campaignArchive.success.title": "Campagne archivée",
	"toast.campaignSubmission.error.title": "Ta soumission n’a pas pu être envoyée",
	"toast.campaignSubmission.success.description": "Ton contenu a été transmis. Tu seras informé·e par e-mail de la décision.",
	"toast.campaignSubmission.success.title": "Soumission envoyée",
	"toast.campaignSubmissionApproval.error.title": "La soumission n’a pas pu être acceptée",
	"toast.campaignSubmissionApproval.success.description.amount": "{amount} confirmés comme rémunération.",
	"toast.campaignSubmissionApproval.success.description.product": "{name} reçoit « {product} » comme rémunération.",
	"toast.campaignSubmissionApproval.success.title": "Soumission acceptée",
	"toast.campaignSubmissionRejection.error.title": "La soumission n’a pas pu être refusée",
	"toast.campaignSubmissionRejection.success.description": "{name} a reçu une notification du refus.",
	"toast.campaignSubmissionRejection.success.title": "Soumission refusée",
	"toast.campaigns.translateWithAi.noSourceLocalization": "Pour permettre à l’IA de traduire votre contenu, au moins une langue doit être entièrement remplie.",
	"toast.changeBillingInformation.error.title": "Erreur lors de la mise à jour des infos de facturation",
	"toast.changeBillingInformation.success.title": "Tes infos de facturation ont été mises à jour",
	"toast.changeBillingInformation.unknownError.title": "Une erreur inconnue est survenue lors de la mise à jour des infos de facturation",
	"toast.changePaymentInformation.error.title": "Erreur lors de la soumission des infos de paiement",
	"toast.changePaymentInformation.success.title": "Tes infos de paiement ont été mises à jour avec succès",
	"toast.changePaymentInformation.unknownError.title": "Une erreur inconnue est survenue lors de la soumission des infos de paiement",
	"toast.changeQuestionaireInformation.error.title": "Erreur lors de la soumission du questionnaire",
	"toast.changeQuestionaireInformation.unkownError.title": "Une erreur inconnue est survenue lors de la soumission du questionnaire",
	"toast.changeQuestionnaireData.error.title": "Erreur lors de la mise à jour des données de candidature",
	"toast.changeQuestionnaireData.success.title": "Tes données de candidature ont été mises à jour",
	"toast.changeQuestionnaireData.unknownError.title": "Une erreur inconnue est survenue lors de la mise à jour des données de candidature",
	"toast.confirmedEmailButNeedLogin.description": "Tu peux maintenant te connecter avec ton e-mail et ton mot de passe",
	"toast.confirmedEmailButNeedLogin.title": "Ton e-mail a été confirmé",
	"toast.copyPromotionLink.error": "Erreur lors de la copie du lien. Merci de réessayer.",
	"toast.createProfile.error.title": "Échec de la création du profil",
	"toast.createProgrammeLink.error.description": "Veuillez réessayer.",
	"toast.createProgrammeLink.error.title": "Le lien n'a pas pu être créé",
	"toast.dateRangePickerMaxRange.error.description": "La plage de dates ne doit pas dépasser {duration}.",
	"toast.dateRangePickerMaxRange.error.title": "Plage de dates trop longue",
	"toast.downloadAsCsv.error.title": "Erreur lors du téléchargement du CSV",
	"toast.downloadReportAsCsv.error.invalidDate": "La date spécifiée est invalide.",
	"toast.downloadReportAsCsv.error.noItems": "Aucun résultat n'a été trouvé.",
	"toast.downloadReportAsCsv.error.parse": "Les données n'ont pas pu être traitées.",
	"toast.downloadReportAsCsv.error.server": "Le rapport n'a pas pu être chargé. Veuillez réessayer plus tard.",
	"toast.editCampaign.success.title": "Campagne mise à jour avec succès",
	"toast.isRedirectedFromAnotherSpace.description": "Vous avez essayé de vous connecter à un autre commerçant. Pour des raisons de sécurité, vous devez à nouveau introduire vos données de connexion.",
	"toast.isRedirectedFromAnotherSpace.title": "Vous devez vous reconnecter",
	"toast.login.error.title": "Échec de la connexion",
	"toast.newCampaign.error.title": "Erreur lors de la création de la campagne",
	"toast.newCampaign.success.title": "Campagne créée avec succès",
	"toast.newPassword.error.title": "Le mot de passe n’a pas pu être changé",
	"toast.newPassword.success.title": "Mot de passe modifié avec succès !",
	"toast.rejectSubmission.success.title": "Soumission rejetée avec succès",
	"toast.resetPassword.error.title": "Le mot de passe n’a pas pu être réinitialisé",
	"toast.saveChannels.error.description": "Un ou plusieurs canaux n'ont pas pu être enregistrés ou supprimés.",
	"toast.saveChannels.error.title": "Erreur lors de l'enregistrement des chaînes",
	"toast.signup.error.title": "Échec de l’inscription",
	"toast.signupWithV1Account.error.description": "Une erreur inconnue est survenue lors de l’inscription. Veuillez vérifier vos informations ou réessayer plus tard.",
	"toast.signupWithV1Account.error.title": "Erreur lors de l’inscription",
	"toast.submitSubmission.error.title": "Erreur lors de la soumission",
	"toast.submitSubmission.unknownError.title": "Une erreur inconnue est survenue lors de la soumission",
	"toast.taxConfirmation.approve.error.title": "La confirmation fiscale n'a pas pu être validée",
	"toast.taxConfirmation.reject.error.title": "La confirmation fiscale n'a pas pu être refusée",
	"toast.unauthorized.description": "Votre session a expiré. Veuillez vous reconnecter.",
	"toast.unauthorized.title": "Vous devez vous reconnecter",
	"toast.updateAccount.admin.success.title": "Profil mis à jour avec succès",
	"toast.updateAccount.error.title": "Ton compte n'a pas pu être mis à jour",
	"toast.updateAccount.success.title": "Ton compte a été mis à jour",
	"toast.updateCampaign.success.title": "Campagne enregistrée avec succès",
	"toast.updateChannels.success.title": "Tes informations de canaux ont bien été enregistrées.",
	"toast.validation.error.description": "Merci de vérifier les champs signalés.",
	"toast.validation.error.title": "Tes informations sont incomplètes",
	"tooltip.blocked": "Accès bloqué",
	"tooltip.cpi.body": "Calculé à partir du volume et de la valeur des conversions générées par le créateur au cours des 90 derniers jours. Plus la valeur est élevée, mieux c’est. Le score maximal est de 10.",
	"tooltip.cpi.title": "Index de performance Clickfire :",
	"tooltip.customProgrammePayoutModality": "Pour ce programme, vous disposez d’un taux de commission personnalisé, plus élevé que la commission standard.",
	"tooltip.decisionDate": "Décidé le {date}",
	"tooltip.inactive": "L'utilisateur n'a pas encore eu de conversions, nous le considérons donc comme inactif.",
	"tooltip.inactive.withDate": "La dernière conversion de l'utilisateur date du {0}, nous le considérons donc comme inactif.",
	"tooltip.v1User.description": "L'utilisateur ne s'est pas encore connecté à Clickfire v2, nous ne pouvons donc pas afficher toutes les données.",
	"tooltip.v1User.label": "Utilisateur v1",
	"topbar.links.admin.applications.history": "Historique des candidatures",
	"topbar.links.admin.applications.onhold": "Candidatures reportées",
	"topbar.links.admin.applications.open": "Candidatures ouvertes",
	"topbar.links.admin.campaigns.active": "Campagnes actives",
	"topbar.links.admin.campaigns.archived": "Archives",
	"topbar.links.admin.campaigns.draft": "Brouillons",
	"topbar.links.admin.taxConfirmations.history": "Vérifiées",
	"topbar.links.admin.taxConfirmations.open": "En attente",
	"topbar.links.affiliates": "Affiliés",
	"topbar.links.applications": "Aperçu des candidatures",
	"topbar.links.availableCampaigns": "Campagnes disponibles",
	"topbar.links.availableProgrammes": "Programmes disponibles",
	"topbar.links.campaigns": "Campagnes",
	"topbar.links.clickReport": "Rapport de clics",
	"topbar.links.clickReportRealtime": "Clics en temps réel",
	"topbar.links.conversions": "Rapport de conversions",
	"topbar.links.dashboard": "Tableau de bord",
	"topbar.links.domains": "Domaines",
	"topbar.links.partnerReport": "Rapport réseau",
	"topbar.links.payouts": "Paiements",
	"topbar.links.productReport": "Rapport sur les produits",
	"topbar.links.productWidget": "Widget Produit",
	"topbar.links.productWidgetsOverview": "Aperçu",
	"topbar.links.programmes": "Programmes",
	"topbar.links.segments": "Groupes de créateurs",
	"topbar.links.submissions": "Propositions",
	"topbar.links.taxConfirmations": "Confirmations fiscales",
	"topbar.links.yourProgrammeApplications": "Tes candidatures",
	"topbar.links.yourProgrammes": "Tes programmes",
	"topbar.userMenu.links.account": "Paramètres du profil",
	"topbar.userMenu.links.adminDashboard": "Tableau de bord commerçant",
	"topbar.userMenu.links.logout": "Déconnexion",
	"topbar.userMenu.links.merchantDashboard": "Tableau de bord affilié",
	"validation.error.bic": "BIC invalide",
	"validation.error.campaign.localizationMinimum": "Au moins une langue doit être spécifiée.",
	"validation.error.campaign.submissionBeforeApplicationDeadline": "La date limite de soumission ne peut pas précéder la date limite de candidature.",
	"validation.error.campaign.type": "Un type de campagne doit être sélectionné.",
	"validation.error.compensation": "La rémunération doit être au moins de 0,01 €",
	"validation.error.confirmTos": "Tu dois accepter les CGU",
	"validation.error.deadline.inPast": "La date ne peut pas être aujourd’hui ou dans le passé",
	"validation.error.deadline.onlyExtendAllowed": "Vous pouvez seulement prolonger la date limite, pas la raccourcir.",
	"validation.error.default": "Entrée invalide",
	"validation.error.duplicate.channelUri": "Cette URL est utilisée pour plusieurs canaux",
	"validation.error.email": "Adresse e-mail invalide",
	"validation.error.iban": "IBAN invalide",
	"validation.error.invalid.date": "Date invalide",
	"validation.error.invalid.url": "URL invalide",
	"validation.error.invalidImageDimensions": "La résolution de l’image est trop faible. Utilise une image d’au moins {width}×{height}px.",
	"validation.error.invalidImageFormat": "Sélectionne un format valide ({0})",
	"validation.error.length": "Ce champ doit contenir au moins {0} caractères.",
	"validation.error.localization.atLeastOne": "Au moins une langue doit être renseignée",
	"validation.error.notANumber": "Nombre invalide",
	"validation.error.notAnImage": "Sélectionne une image valide",
	"validation.error.notEqual": "Les mots de passe ne correspondent pas",
	"validation.error.number.noFloat": "Ce champ ne peut pas contenir de nombres à virgule",
	"validation.error.postalCode": "Code postal non valide pour {country}",
	"validation.error.required": "Ce champ est requis",
	"validation.error.startDate": "La date de début ne peut pas être antérieure au {0}",
	"validation.error.tags.required": "Au moins une étiquette de contenu est requise",
	"validation.error.tooBig.number": "Le nombre ne peut pas être supérieur à {0}.",
	"validation.error.tooSmall.array": "Ce champ est requis",
	"widget.affilateDetails.accountManager": "Gestionnaire de compte",
	"widget.affilateDetails.subId1": "Affilié sous-ID 1",
	"widget.affilateDetails.subId2": "Affilié sous-ID 2",
	"widget.affilateDetails.title": "Affiliés",
	"widget.networkSelectionPerformanceGraph.action.clearSelection": "Effacer la sélection",
	"widget.networkSelectionPerformanceGraph.action.removeFromSelection": "Retirer de la sélection",
	"widget.networkSelectionPerformanceGraph.label.selection": "Sélection :",
	"widget.networkSelectionPerformanceGraph.label.wholeNetwork": "Réseau entier",
	"widget.payment.billingAndTaxes.title": "Facturation & taxes",
	"widget.payment.billingData.title": "Données de facturation",
	"widget.payment.misc.title": "Divers",
	"widget.payment.paymentInfo.title": "Informations de paiement",
	"widget.payment.taxConfirmation.approved.action": "Soumettre à nouveau",
	"widget.payment.taxConfirmation.approved.description": "Tes informations ont changé, par exemple après un déménagement ? Soumets alors à nouveau la confirmation.",
	"widget.payment.taxConfirmation.approved.title": "Confirmation fiscale validée",
	"widget.payment.taxConfirmation.missing.action": "Remplir maintenant",
	"widget.payment.taxConfirmation.missing.description": "Comme tu résides en Allemagne, nous avons besoin d'une confirmation de ton statut fiscal. Tes paiements sont suspendus jusqu'à sa validation.",
	"widget.payment.taxConfirmation.missing.descriptionNotPaused": "Comme tu résides en Allemagne, nous avons besoin d'une confirmation de ton statut fiscal.",
	"widget.payment.taxConfirmation.missing.title": "Confirmation fiscale requise",
	"widget.payment.taxConfirmation.pending.description": "Tes paiements reprendront dès que nous aurons validé ta confirmation fiscale.",
	"widget.payment.taxConfirmation.pending.descriptionNotPaused": "Nous vérifions tes informations et te recontactons si quelque chose ne va pas.",
	"widget.payment.taxConfirmation.pending.title": "Confirmation fiscale en cours de vérification",
	"widget.payment.taxConfirmation.rejected.action": "Remplir à nouveau",
	"widget.payment.taxConfirmation.rejected.description": "Motif : {reason}. Merci de remplir à nouveau la confirmation – tes paiements sont suspendus d'ici là.",
	"widget.payment.taxConfirmation.rejected.descriptionNotPaused": "Motif : {reason}. Merci de remplir à nouveau la confirmation.",
	"widget.payment.taxConfirmation.rejected.descriptionWithoutReason": "Merci de remplir à nouveau la confirmation – tes paiements sont suspendus d'ici là.",
	"widget.payment.taxConfirmation.rejected.descriptionWithoutReasonNotPaused": "Merci de remplir à nouveau la confirmation.",
	"widget.payment.taxConfirmation.rejected.title": "Confirmation fiscale refusée",
	"widget.performanceGraph.conversionStatusFilter.label": "État des conversions",
	"widget.performanceGraph.label.clicks": "Clics",
	"widget.performanceGraph.label.conversions": "Conversions",
	"widget.performanceGraph.label.payouts": "Valeur des commissions",
	"widget.performanceGraph.label.sales": "Sales Value",
	"widget.performanceGraph.missingPublisherId.description": "Les données de performance ne peuvent pas être chargées pour ce partenaire.",
	"widget.performanceGraph.missingPublisherId.title": "Aucun identifiant publisher enregistré",
	"widget.performanceGraph.title": "Graphique de performance",
	"widget.performanceGraph.trend": "Tendance",
	"widget.topProducts.noContent": "Aucun produit trouvé pour cette période.",
	"widget.yourAffiliateLinks.title": "Tes liens d’affiliation",
	"widget.yourApplications.title": "Statut de tes candidatures"
}
